import React, { useState, useEffect, useRef } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { auth, db } from "../firebase";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import CheckIcon from '@mui/icons-material/Check';
import _ from 'lodash';
import {
  collection,
  doc,
  getDoc,
  updateDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp
} from "firebase/firestore/lite";
import https from "https";

import { Card, Button, Container, useMediaQuery, ToggleButton, ToggleButtonGroup,
   ButtonBase, RadioGroup, FormControlLabel, Radio, Select, FormControl, MenuItem } from "@mui/material";
import styled from "styled-components";
import { useParams, useLocation } from "react-router-dom";
import {
  AudioWrapper,
  BEGIN_TEST,
  VOCAB_TEST,
  VOCABULARY,
  APT_TEST,
  StyledLink,
  transcribeAudio,
  COMPREHENSIVE_TEST,
  EMOTIONAL_INTELLIGENCE_TEST,
  APTITUDE_TECHNICAL_TEST,
  CALL_CENTER_KNOWLEDGE_TEST,
  CUSTOMER_SERVICE_TEST,
  SALES_TEST,
  ATTENTION_TO_DETAIL_TEST,
  TECH_SUPPORT,
  SALES_RETENTION_TEST,
  LISTENING_TEST,
  CEFR_READING_TEST,
  CEFR_LISTENING_TEST,
  CEFR_WRITING_TEST,
  RETENTION_LISTENING_TEST,
  ALTICE_QUESTIONS_TEST,
  INTEGRITY_TEST,
  ATTENDANCE_TEST
} from "./helper";
import Banner from "./Banner";
import { diff_match_patch } from "diff-match-patch";
import ErrorIcon from "@material-ui/icons/Error";
import MySpinner from "./MySpinner";
import { Tooltip } from "./StyledComps";
import SoftTypography from "./SoftTypography";
import SoftBox from "./SoftBox";
import SoftInput from "./SoftInput";
import SoftButton from "./SoftButton";
import { PDFViewer, Document, Page, Text, pdf } from "@react-pdf/renderer";
import ReactDOMServer from "react-dom/server";
import TagManager from "react-gtm-module";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import step from "../assets/theme/components/stepper/step";
import { generateEmailBody, generateOutEmailBody } from "../globals/utils";
import { RotatingLines } from "react-loader-spinner";
import { exception } from "react-ga";

const UserTranscribe = styled.p`
  overflow-x: hidden;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const DiffWrapper = styled.span`
  position: relative;
  display: inline-block;
  cursor: pointer;
  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const DiffAdd = styled.span`
  background-color: #c8f7c5;
  &:hover {
    background-color: #8be38c;
  }
`;

const DiffDelete = styled.span`
  background-color: #ffb6ba;
  &:hover {
    background-color: #ff7f7f;
  }
`;

const TypingTestReviewCard = ({ vocab }) => {
  const textToType = vocab?.text_to_type || "";
  const typedText = vocab?.answer || "";
  const wpm = vocab?.wpm ?? "--";
  const accuracy = vocab?.accuracy ?? "--";
  const elapsed = vocab?.elapsed_seconds ?? 0;

  const formatElapsed = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const renderDiff = () => {
    if (!textToType) return null;
    return (
      <span>
        {textToType.split("").map((char, i) => {
          let color = "#4F4F4F";
          let bg = "transparent";
          let td = "none";
          if (i < typedText.length) {
            if (typedText[i] === char) {
              color = "#16a34a";
            } else {
              color = "#dc2626";
              bg = "#fee2e2";
              td = "underline";
            }
          }
          return (
            <span key={i} style={{ color, backgroundColor: bg, textDecoration: td }}>
              {char}
            </span>
          );
        })}
        {typedText.length > textToType.length && (
          <span style={{ color: "#dc2626", backgroundColor: "#fee2e2" }}>
            {typedText.slice(textToType.length)}
          </span>
        )}
      </span>
    );
  };

  return (
    <Card mb={2} variant="outlined" style={{ marginBottom: "1rem", boxShadow: "none", borderRadius: "8px" }}>
      <SoftBox position="relative" sx={{ width: "100%", backgroundColor: "#EAEAEA" }}>
        <SoftBox lineHeight={0}>
          <SoftBox mb={1} padding={"15px 15px 5px 15px"}>
            <SoftTypography
              variant="h6"
              color="dark"
              style={{ textAlign: "left", paddingBottom: "8px", fontSize: "16px", fontWeight: "400", color: "#4F4F4F" }}
            >
              {vocab?.title || "Typing Test"}
            </SoftTypography>
            <SoftTypography
              variant="h6"
              color="dark"
              style={{ textAlign: "left", paddingBottom: "8px", fontSize: "16px", fontWeight: "400", color: "#4F4F4F" }}
            >
              WPM: {wpm} &nbsp;&nbsp; Accuracy: {accuracy}% &nbsp;&nbsp; Time: {formatElapsed(elapsed)}
            </SoftTypography>
          </SoftBox>
          <SoftBox px={2} sx={{ backgroundColor: "white !important" }}>
            <SoftBox padding={"5px"}>
              <SoftTypography variant="h6" color="text" style={{ lineHeight: "1.6" }}>
                Passage (green = correct, red = error): &nbsp;&nbsp;&nbsp;
              </SoftTypography>
              <SoftTypography
                variant="h6"
                color="text"
                component="div"
                style={{ lineHeight: "1.6", fontSize: "16px", fontWeight: "400", paddingTop: "4px" }}
              >
                {renderDiff()}
              </SoftTypography>
            </SoftBox>
            <SoftBox padding={"5px"} mt={1} mb={1}>
              <SoftTypography variant="h6" color="text">
                Candidate's Typed Text: &nbsp;&nbsp;&nbsp;
              </SoftTypography>
              <SoftTypography
                variant="h6"
                color="text"
                component="div"
                style={{ lineHeight: "1.6", fontSize: "16px", fontWeight: "400", color: "#4F4F4F", paddingTop: "4px" }}
              >
                {typedText || "No text typed"}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </Card>
  );
};

const VocabCard = ({ vocab, lastItem, sectionQuestionNumber = 1, sectionTotalQuestions = 1 }) => {
  // Typing Test: special rendering
  if (vocab?.type === "TYPING_TEST" || vocab?.category === "typing_test") {
    return <TypingTestReviewCard vocab={vocab} />;
  }

  // Chat Scenario: uses same passage+questions layout as short_reading
  if (vocab?.category === "short_reading" ||
    vocab?.category === "retention_questions" ||
    vocab?.category === "attendance_es" ||
    vocab?.category === "attendance" ||
    vocab?.category === "chat_scenario") {
    return (
      <>
        <Card mb={2} variant="outlined" style={{ marginBottom: "1rem", backgroundColor: "#f5f5f5" }}>
          <SoftBox p={2}>
            <SoftTypography
              variant="h6"
              color="dark"
              style={{ textAlign: "left", fontSize: "16px", fontWeight: "400", color: "#4F4F4F" }}
              dangerouslySetInnerHTML={{ __html: vocab.paragraph_text }}
            />
          </SoftBox>
        </Card>

        {vocab.questions.map((questionObj, index) => (
          <Card
            key={index}
            mb={2}
            variant="outlined"
            style={{
              marginBottom: "1rem",
              boxShadow: "none",
              borderRadius: "8px"
            }}
          >
            <SoftBox position="relative">
              <SoftBox lineHeight={0}>
                <SoftBox
                  sx={{
                    width: "100%",
                    backgroundColor: "#EAEAEA !important",
                    padding: "15px"
                  }}
                >
                  <SoftTypography
                    variant="h6"
                    color="dark"
                    style={{
                      textAlign: "left",
                      paddingBottom: "8px",
                      fontSize: "16px",
                      fontWeight: "400",
                      color: "#4F4F4F"
                    }}
                    dangerouslySetInnerHTML={{ __html: questionObj?.question }}
                  />
                  <SoftTypography
                    variant="h6"
                    color="dark"
                    style={{
                      textAlign: "left",
                      paddingBottom: "8px",
                      fontSize: "16px",
                      fontWeight: "400",
                      color: "#4F4F4F"
                    }}
                  >
                    Q {sectionQuestionNumber + index} of {sectionTotalQuestions}
                  </SoftTypography>
                </SoftBox>

                <SoftBox px={2}>
                  <SoftBox mt={2}>
                    <SoftTypography variant="h6" fontWeight="medium" color="text">
                      Answered: &nbsp;&nbsp;&nbsp;
                      {Array.isArray(questionObj.answer)
                        ? questionObj.answer.join(", ")
                        : questionObj.answer}
                    </SoftTypography>
                  </SoftBox>

                  <SoftBox mt={2} mb={1.5}>
                    <SoftTypography
                      variant="h6"
                      color="text"
                      style={{ display: "flex", flexDirection: "row" }}
                    >
                      Correct Answer: &nbsp;&nbsp;&nbsp;
                      {(() => {
                        let parsedCorrectAnswer = [];

                        if (Array.isArray(questionObj.correct_answer)) {
                          parsedCorrectAnswer = questionObj.correct_answer;
                        } else if (typeof questionObj.correct_answer === "string") {
                          try {
                            const parsed = JSON.parse(
                              questionObj.correct_answer.replace(/'/g, '"')
                            );
                            parsedCorrectAnswer = Array.isArray(parsed)
                              ? parsed
                              : [parsed];
                          } catch (error) {
                            parsedCorrectAnswer = [questionObj.correct_answer];
                          }
                        } else {
                          parsedCorrectAnswer = [questionObj.correct_answer];
                        }

                        const userAnswerArray = Array.isArray(questionObj.answer)
                          ? questionObj.answer
                          : [questionObj.answer];

                        const sortedUserAnswer = userAnswerArray.map(String).sort();
                        const sortedCorrectAnswer = parsedCorrectAnswer.map(String).sort();

                        const isAnswerCorrect =
                          JSON.stringify(sortedUserAnswer) ===
                          JSON.stringify(sortedCorrectAnswer);

                        const formattedCorrectAnswer =
                          parsedCorrectAnswer?.length > 0
                            ? parsedCorrectAnswer.join(", ")
                            : "N/A";

                        return isAnswerCorrect ? (
                          <SoftTypography
                            variant="h6"
                            color="green"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              color: "green"
                            }}
                          >
                            {formattedCorrectAnswer}
                          </SoftTypography>
                        ) : (
                          <SoftTypography
                            variant="h6"
                            fontWeight="medium"
                            color="red"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              color: "red"
                            }}
                          >
                            {formattedCorrectAnswer}
                            <ErrorIcon
                              fontSize="small"
                              style={{
                                marginLeft: "5px",
                                paddingBottom: "3px",
                                color: "red"
                              }}
                            />
                          </SoftTypography>
                        );
                      })()}
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </Card>
        ))}
      </>
    );
  }

  return (
    <Card mb={2} variant="outlined" style={{ marginBottom: "1rem", boxShadow: "none", borderRadius: "8px" }}>
      <SoftBox position="relative" sx={{ width: "100%", backgroundColor: "#EAEAEA" }}>
        <SoftBox lineHeight={0}>
          <SoftBox mb={1} padding={"15px 15px 5px 15px"}>
            <SoftTypography
              variant="h6"
              color="dark"
              style={{ textAlign: "left", paddingBottom: "8px", fontSize: "16px", fontWeight: "400", color: "#4F4F4F" }}
              dangerouslySetInnerHTML={{ __html: vocab?.question }}
            />
            {vocab.description && (
              <SoftTypography
                component="div"
                style={{
                  textAlign: "left",
                  paddingBottom: "10px",
                  color: "#4F4F4F",
                  fontSize: "16px",
                  fontWeight: "400",
                  paddingLeft: /<\s*(ul|ol|li)[^>]*>/i.test(vocab.description) ? "16px" : "0px",
                }}
                dangerouslySetInnerHTML={{
                  __html: `
                    <style>
                      ul, ol {
                        margin: 0 0 10px 20px;
                        padding: 0;
                        list-style: disc;
                      }
                      ol {
                        list-style: decimal;
                      }
                      li {
                        margin-bottom: 6px;
                        display: list-item;
                      }
                    </style>
                    ${vocab.description}
                  `,
                }}
              />
            )}
            <SoftTypography
              variant="h6"
              color="dark"
              style={{ textAlign: "left", paddingBottom: "8px", fontSize: "16px", fontWeight: "400", color: "#4F4F4F" }}
            >
              Q {sectionQuestionNumber} of {sectionTotalQuestions}
            </SoftTypography>
          </SoftBox>
          <SoftBox px={2} sx={{ backgroundColor: "white !important" }}>
            <SoftBox padding={"5px"}>
              <SoftTypography variant="h6" color="text">
                Answered: &nbsp;&nbsp;&nbsp;
                {Array.isArray(vocab.answer) ? vocab.answer.join(", ") : vocab.answer}
              </SoftTypography>
            </SoftBox>
            {vocab?.category !== "short_response" && vocab?.category !== "structured_response" && (
              <SoftBox padding={"5px"}>
                <SoftTypography
                  variant="h6"
                  color="text"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  Correct Answer: &nbsp;&nbsp;&nbsp;
                  {(() => {
                    let parsedCorrectAnswer = [];

                    if (Array.isArray(vocab.correct_answer)) {
                      parsedCorrectAnswer = vocab.correct_answer;
                    } else if (typeof vocab.correct_answer === "string") {
                      try {
                        const parsed = JSON.parse(vocab.correct_answer.replace(/'/g, '"'));
                        parsedCorrectAnswer = Array.isArray(parsed) ? parsed : [parsed];
                      } catch (error) {
                        parsedCorrectAnswer = [vocab.correct_answer];
                      }
                    } else {
                      parsedCorrectAnswer = [vocab.correct_answer];
                    }

                    const sortedUserAnswer = (Array.isArray(vocab.answer) ? vocab.answer : [vocab.answer])
                      .map(String)
                      .sort();

                    const sortedCorrectAnswer = parsedCorrectAnswer
                      .map(String)
                      .sort();

                    const isAnswerCorrect =
                      JSON.stringify(sortedUserAnswer) === JSON.stringify(sortedCorrectAnswer);

                    const formattedCorrectAnswer =
                      parsedCorrectAnswer?.length > 0 ? parsedCorrectAnswer.join(", ") : "N/A";

                    return isAnswerCorrect ? (
                      <SoftTypography
                        variant="h6"
                        color="green"
                        style={{ display: "flex", flexDirection: "row", color: "green" }}
                      >
                        {formattedCorrectAnswer}
                      </SoftTypography>
                    ) : (
                      <SoftTypography
                        variant="h6"
                        color="red"
                        style={{ display: "flex", flexDirection: "row", color: "red" }}
                      >
                        {formattedCorrectAnswer}
                        <ErrorIcon
                          fontSize="small"
                          style={{ marginLeft: "5px", paddingBottom: "3px", color: "red" }}
                        />
                      </SoftTypography>
                    );
                  })()}
                </SoftTypography>
              </SoftBox>
            )}
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </Card>
  );
};

export default function Details() {

  const [user, setUser] = useState();
  const [assessments, setAssessments] = useState([]);
  const [assessment, setAssessment] = useState();

  const [loadingAudios, setLoadingAudios] = useState(true);
  const [isLoading, setIsLoading] = useState();
  const [validationError, setValidationError] = useState("");

  const [reviewSteps, setReviewSteps] = useState([]);

  const [sectionKeyMapping, setSectionKeyMapping] = useState([]);
  const [collapsedSections, setCollapsedSections] = useState([]);
  const [regionMap, setRegionMap] = useState({});
  const [startTime, setStartTime] = useState("");

  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);

  const [selected, setSelected] = useState("");
  const [regions, setRegions] = useState([]);

  const [vocabText, setVocabText] = useState([]);

  const [selectedReasons, setSelectedReasons] = useState([]);
  const [cefrScoreRecruiter, setCefrScoreRecruiter] = useState("");
  const [recruiterOutcome, setRecruiterOutcome] = useState("");
  const [scenarioGrades, setScenarioGrades] = useState({});
  const [scenarioFeedback, setScenarioFeedback] = useState({});
  const [scenarioGradeSaving, setScenarioGradeSaving] = useState({});
  const passReasonArray = ['Good Clarity', 'Fluent & Natural', 'Good vocabulary & grammer'];
  const setFailReasonsArray = ['Limited vocabulary & Grammar', 'Lacked clarity & Structure', 
    'Language barrier', 'Lacked reasoning ability'];
  const [passReasons, setPassReasons] = useState(_.shuffle(passReasonArray));
  const [failReasons, setFailReasons] = useState(_.shuffle(setFailReasonsArray)); 

  const [grammerTime, setGrammerTime] = useState("");
  const [aptitudeTime, setAptitudeTime] = useState("");
  const [aptitudeTechnicalTime, setAptitudeTechnicalTime] = useState("");
  const [comprehensiveTime, setComprehensiveTime] = useState("");
  const [emotionalIntelligenceTime, setEmotionalIntelligenceTime] = useState("");
  const [callCenterKnowledgeTime, setCallCenterKnowledgeTime] = useState("");
  const [customerServiceTime, setCustomerServiceTime] = useState("");
  const [salesTime, setSalesTime] = useState("");
  const [attentionTime, setAttentionTime] = useState("");
  const [techSupportTime, setTechSupportTime] = useState("");
  const [salesRetentionTime, setSalesRetentionTime] = useState("");
  const [cefrReadingTime, setCefrReadingTime] = useState("");
  const [cefrListeningTime, setCefrListeningTime] = useState("");
  const [cefrWritingTime, setCefrWritingTime] = useState("");
  const [cefrSpeakingInteractionTime, setCefrSpeakingInteractionTime] = useState("");
  const [cefrSpeakingTopicTime, setCefrSpeakingTopicTime] = useState("");
  const [cefrSpeakingIntroTime, setCefrSpeakingIntroTime] = useState("");
  const [recordingTime, setRecordingTime] = useState("");
  const [listeningTime, setListeningTime] = useState("");
  const [retentionListeningTime, setRetentionListeningTime] = useState("");
  const [alticeQuestionsTime, setAlticeQuestionsTime] = useState("");
  const [integrityTime, setIntegrityTime] = useState("");
  const [attendanceTime, setAttendanceTime] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [jobId, setJobId] = useState("");
  const [listeningTestArray, setListeningTestArray] = useState([]);
  const [testStatus, setTestStatus] = useState(null);
  const [success, setSuccess] = useState(false);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [feedbackPass, setFeedbackPass] = useState(false);
  const [audioUrls, setAudioUrls] = useState({});
  const [isAudioLoading, setIsAudioLoading] = useState(true);
  const [imageUrls, setImageUrls] = useState(null);
  const [loadingImages, setLoadingImages] = useState(true);
  const printRef = React.useRef();
  const [forceExpandForPDF, setForceExpandForPDF] = useState(false);
  const [mediaStatus, setMediaStatus] = useState({
    speakingLoaded: 0,
    listeningLoaded: 0,
    imageLoaded: false,
  });
  const [isExporting, setIsExporting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const mediaStatusRef = useRef(mediaStatus);
  const [isSinglePage, setIsSinglePage] = useState(false);

  let { q } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const reload = params.get("reload") === "true";

  const outcomeOptions = [
    { value: "accept", label: "Accept" },
    { value: "reject", label: "Reject" }
  ];

  const outcomeOptions1 = [
    { value: "accept", label: "Accepted" },
    { value: "reject", label: "Rejected" }
  ];

  const SCREENING = "Screening";
  const REVIEW_RECORDING = "Review Recording";
  const REVIEW_QUESTIONS = "Review Questions";
  const REVIEW_LISTENING = "Review Listening";
  const FEEDBACK = "Feedback";
  const REVIEW_SPEAKING = "Review Speaking";
  const REVIEW_WRITING = "Review Writing";

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [isRescoring, setIsRescoring] = useState(false);
  const [rescoreMessage, setRescoreMessage] = useState("");

  // A spoken section that has a transcript but no score means ML never
  // returned one for it — app.py writes null when the scoring call fails, so
  // null is the failure signal and the section can usefully be rescored.
  //
  // Zero is NOT a failure. It is what the grader returns when a candidate
  // said nothing usable, or when the relevance check rejects the answer, and
  // it is by far the most common outcome on these sections. Counting it here
  // put a "Rescore ML (1 unscored)" banner on 11,116 of 27,562 finished
  // candidates, 10,999 of which had nothing wrong with them at all.
  const failedSpokenSections = React.useMemo(() => {
    if (!assessment) return [];
    return Object.keys(assessment)
      .filter((k) => k.endsWith("_transcribe") && assessment[k])
      .map((k) => k.replace(/_transcribe$/, ""))
      .filter((topic) => topic.startsWith("speaking_") || topic.startsWith("audio_scenario_"))
      .filter((topic) => {
        const score = assessment[`${topic}_score`];
        return score === null || score === undefined;
      });
  }, [assessment]);

  const handleRescoreClick = async () => {
    if (!assessment?.uid) return;
    setIsRescoring(true);
    setRescoreMessage("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/rescore_sections`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ assessmentUid: assessment.uid }),
        }
      );
      const data = await response.json();

      if (!response.ok) {
        setRescoreMessage(data.error || "Rescore failed.");
        return;
      }

      if (data.rescored > 0) {
        // Totals are recalculated server-side; reload to pick them up.
        setRescoreMessage(`Rescored ${data.rescored} section(s). Refreshing...`);
        setTimeout(() => window.location.reload(), 1200);
      } else {
        const blocked = (data.sections || []).find((s) => s.status === "no_transcript");
        const short = (data.sections || []).find((s) => s.status === "too_short");
        if (blocked) {
          setRescoreMessage("Nothing rescored — that section has no transcript, the audio must be re-submitted.");
        } else if (short) {
          setRescoreMessage(`Nothing rescored — the answer is too short to grade (${short.word_count} words, minimum ${short.min_words}).`);
        } else {
          setRescoreMessage("Nothing to rescore — all sections already have a score.");
        }
      }
    } catch (err) {
      console.error("Rescore error:", err);
      setRescoreMessage("Could not reach the scoring service.");
    } finally {
      setIsRescoring(false);
    }
  };

  useEffect(() => {
    if (reload) {
      // Fire the API call
      const updateStatus = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/update_assessment_status`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                assessmentUid: assessment.uid,
                testName: assessment.test_name,
              }),
            }
          );

          if (!response.ok) throw new Error("Failed to update status");
          const data = await response.json();
          console.log("Status updated:", data);
        } catch (err) {
          console.error("Error updating status:", err);
        }
      };

      updateStatus();
    }
  }, [reload, assessment]);


  useEffect(() => {
    const regionsData = [];
    const regionRef = collection(db, "regions");
    // const regionMap = {}
    getDocs(regionRef)
      .then(async (querySnapshot) => {
        querySnapshot.forEach((docSnapshot) => {
          const region = docSnapshot.data()
          regionsData.push(region);
          // regionMap[region.region] = region
        });
        setRegions(regionsData);
        // setRegionMap(regionMap);
      })
      .catch((error) => {
        console.error("Error getting document: ", error);
      })
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const userRef = doc(db, "users", q);

    getDoc(userRef)
      .then(async (docSnapshot) => {
        if (docSnapshot.exists()) {
          const userData = docSnapshot.data();
          userData.id = docSnapshot.id;

          const q1 = query(
            collection(db, "assessments"),
            where("userId", "==", docSnapshot.id),
            orderBy("createdAt", "desc"),
            limit(20)
          );
          const querySnapshot = await getDocs(q1);
          if (!querySnapshot.empty) {
            const assessment = querySnapshot.docs[0].data();
            assessment.uid = querySnapshot.docs[0].id;
  
            setAssessment(assessment);
            // setTestTimes(assessment);
  
            setFeedback(assessment.feedback);
            setJobId(assessment.job_id);
            setRecruiterOutcome(assessment.recruiter_outcome || "");
            setSelectedReasons(assessment.selected_reasons || []);
            setCefrScoreRecruiter(assessment.cefr_score_recruiter || "");
            // Load existing scenario recruiter grades and feedback
            const grades = {};
            const fbk = {};
            Object.keys(assessment).forEach(key => {
              if (key.startsWith("audio_scenario_") && key.endsWith("_recruiter_grade")) {
                const sectionKey = key.replace("_recruiter_grade", "");
                grades[sectionKey] = assessment[key];
              }
              if (key.startsWith("audio_scenario_") && key.endsWith("_recruiter_feedback")) {
                const sectionKey = key.replace("_recruiter_feedback", "");
                fbk[sectionKey] = assessment[key];
              }
            });
            setScenarioGrades(grades);
            setScenarioFeedback(fbk);
            setAudioUrl(assessment.audioUrl);
            fetchAllAudioUrls(assessment);
            fetchImageUrls(assessment)
            setIsLoading(false);

            setVocabText(assessment.vocabtext || []);
            if (assessment && assessment.currentStep) {
              setTestStatus(assessment.currentStep);
            }
  
            if (assessment.listeningAnswer) {
              const groupedAnswers = assessment.listeningAnswer.reduce(
                (acc, curr) => {
                  if (!acc[curr.audioFile]) {
                    acc[curr.audioFile] = [];
                  }
                  acc[curr.audioFile].push(curr);
                  return acc;
                },
                {}
              );
              const groupedAnswersArray = Object.entries(groupedAnswers).map(
                ([audioFile, answers]) => ({
                  audioFile,
                  answers,
                })
              );
  
              setListeningTestArray(groupedAnswersArray);
            }
  
            const assessmentArray = querySnapshot.docs.map((doc) => {
              const assessment = doc.data();
              assessment.uid = doc.id;
              return assessment;
            });
            setAssessments(assessmentArray);
            handleStepsNavigation(assessment)
          }
          setUser(userData);
        } else {
          console.log("Document not found!");
        }
      })
      .catch((error) => {
        console.error("Error getting document: ", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [q]);

  useEffect(() => {
    if (assessment && regions.length > 0) {
      const selectedRegion = regions.find(region => region.region === assessment.region);
      const selectedTest = assessment.test_name
        ? selectedRegion?.tests?.[assessment.test_name] || null
        : null;

      const sections = selectedTest?.sections || [];
      const updatedList = [];
      const timeData = {};

      // Convert Firebase timestamp to JS Date
      const startDate = new Date(0);
      startDate.setUTCSeconds(assessment.started_time?.seconds || 0);
      timeData["BEGIN_TEST"] = startDate;

      let lastStepTime = startDate;
      let previousStepDate = startDate;

      const steps_test = assessment.steps || [];


      // let lastStep = ''
      // const steps_test = assessment?.steps
      // sections.forEach((element, index) => {
      //   console.log('whats this 2222', element)
      //   const stepTime = assessment[element.time]
      //   if (steps_test.includes(element.field))
      //     lastStep = element.time
      //   const previousStepDate = timeData[sections[index - 1]] || startDate;
      //   const stepDate = new Date(0);
      //   try {
      //     stepDate.setUTCSeconds(stepTime?.seconds);
      //   } catch (error) {
      //     return
      //   }
        
      //   const deltaTime = Math.abs(stepDate - previousStepDate);

      sections.forEach((element) => {
        const stepTime = assessment[element.time];
        if (!stepTime) return;

        const stepDate = new Date(0);
        stepDate.setUTCSeconds(stepTime.seconds || 0);

        const deltaTime = Math.abs(stepDate.getTime() - previousStepDate.getTime());

        // Save step's timestamp for later use
        timeData[element.time] = stepDate;

        const minutes = Math.floor(deltaTime / 1000 / 60);
        const seconds = Math.floor((deltaTime / 1000) % 60);
        const myTime = formatTime(minutes, seconds);

        const obj = {
          key: element.field,
          heading: element.heading,
          sub_heading: element.sub_heading,
          value: assessment[element.field] || [],
          score: assessment[element.score] || 0,
          time1: stepTime || 0,
          time: myTime,
          minutes,
          seconds,
        };

        updatedList.push(obj);

        // Update previousStepDate for the next iteration
        previousStepDate = stepDate;

        // Update lastStepTime for overall duration
        if (steps_test.includes(element.field)) {
          lastStepTime = stepDate;
        }
      });

      setCollapsedSections(updatedList.reduce((acc, section) => {
        acc[section.key] = section.key !== "Vocabulary";
        return acc;
      }, {}));

      // Compute overall test duration
      const overallTime = Math.abs(lastStepTime.getTime() - startDate.getTime());
      const overAllMinutes = Math.floor(overallTime / 1000 / 60);
      const overAllSeconds = Math.floor((overallTime / 1000) % 60);
      setStartTime(formatTime(overAllMinutes, overAllSeconds));
      setSectionKeyMapping(updatedList);
    }
  }, [assessment, regions]);

  useEffect(() => {
    setMediaStatus((prev) => ({
      ...prev,
      speakingLoaded: 0,
      listeningLoaded: 0,
      imageLoaded: false,
    }));
  }, []);

  const updateMediaStatus = (newStatus) => {
    mediaStatusRef.current = { ...mediaStatusRef.current, ...newStatus };
    setMediaStatus(mediaStatusRef.current);
  };

  const waitForSpeakingMediaToLoad = async (timeout = 120000, interval = 500) => {
    // Skip waiting if CEFR speaking scores are missing (audio scenarios load differently)
    const hasCefrSpeaking = assessment?.steps?.some(step => step.startsWith("speaking_"));
    if (
      !hasCefrSpeaking ||
      !assessment?.speaking_intro_score ||
      !assessment?.speaking_topic_score ||
      !assessment?.speaking_interaction_score
    ) {
      console.log("Skipping speaking media load check — CEFR speaking not present or scores missing.");
      return;
    }
  
    const startTime = Date.now();
  
    while (true) {
      const { speakingLoaded } = mediaStatusRef.current;
  
      const allSpeakingLoaded = speakingLoaded >= 3;
  
      if (allSpeakingLoaded) {
        console.log("Speaking media loaded. Waiting extra 2 seconds...");
        await new Promise((resolve) => setTimeout(resolve, 2000));
        break;
      }
  
      if (Date.now() - startTime > timeout) {
        throw new Error("Timed out waiting for speaking media to load");
      }
  
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
  };
  
  const handleOutcomeSelect = (value) => {
    if (value !== recruiterOutcome) {
      setRecruiterOutcome(value);
      setSelectedReasons([]);
    }
  };

  const handleReasonsChange = (event, newReasons) => {
    setSelectedReasons(newReasons);
  };

  const reasonOptions = recruiterOutcome === "accept" ? passReasons : recruiterOutcome === "reject" ? failReasons : [];

  const handleExportClick = async () => {
  
    setErrorMessage('');
  
    // Stop export if assessment is not started
    if (assessment?.currentStep === 'BEGIN_TEST') {
      setErrorMessage('Selected assessment is not started yet.');
    
      // Hide after 5 seconds
      setTimeout(() => {
        setErrorMessage('');
      }, 5000);
    
      setIsExporting(false);
      return;
    }
  
    setIsExporting(true);
  
    try {
      await waitForSpeakingMediaToLoad();
  
      setForceExpandForPDF(true);
      await new Promise((resolve) => setTimeout(resolve, 1500));
  
      const input = document.getElementById("my-pdf");
      if (!input) throw new Error("PDF element not found");
  
      input.style.display = "block";
  
      const canvas = await html2canvas(input, {
        scrollY: -window.scrollY,
        useCORS: true,
      });
  
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
        putOnlyUsedFonts: true,
        compress: true,
      });
  
      const imgWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let position = 0;
  
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  
      const numExtraPages = Math.ceil(
        (imgHeight - pdf.internal.pageSize.getHeight()) / pdf.internal.pageSize.getHeight()
      );
  
      for (let i = 1; i <= numExtraPages; i++) {
        pdf.addPage();
        position -= pdf.internal.pageSize.getHeight();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      }
  
      input.style.display = "none";
      setForceExpandForPDF(false);
      setIsExporting(false);
  
      pdf.save(user.email + ".pdf");
    } catch (err) {
      console.error("Export failed:", err);
      alert("Failed to export PDF. Please try again.");
      setForceExpandForPDF(false);
      setIsExporting(false);
    }
  };    

  const section_header = [

    { key: "attendance_es", value: "Vocabulary and Grammar" },
    { key: "integrity_es", value: "Vocabulary and Grammar" },
    { key: "call_center_knowledge_es", value: "Vocabulary and Grammar" },
    { key: "emotional_intelligence_es", value: "Vocabulary and Grammar" },
    { key: "customer_service_es", value: "Vocabulary and Grammar" },

    { key: "Vocabulary", value: "Vocabulary and Grammar" },
    { key: "aptitude", value: "Apptitude w/Technical" },
    { key: "comprehensive", value: "Comprehension" },
    { key: "emotional_intelligence", value: "Emotional Intelligence" },
    { key: "integrity", value: "Integrity" },
    { key: "attendance", value: "Attendance" },
    { key: "call_center_knowledge", value: "Call Center Knowledge" },
    { key: "aptitude_technical", value: "Aptitude & Technical" },
    { key: "customer_service", value: "Customer Service" },
    { key: "sales", value: "Sales" },
    { key: "attention", value: "Attention to Detail" },
    { key: "tech_support", value: "Technical Proficiency" },
    { key: "sales_retention", value: "Sales & Retention" },
    { key: "cefr_reading", value: "Reading & Grammar" },
    { key: "listening", value: "Listening" },
    { key: "listeningAnswer", value: "Listening" },
    { key: "cefr_listening", value: "Listening" },
    { key: "cefr_writing", value: "Writing" },
    { key: "retention_listening", value: "Retention Listening" },
    { key: "altice_question", value: "Altice Questions" },
  ];

  const fetchSignedUrl = async (filename) => {
    try {
      const apiUrl = `${process.env.REACT_APP_SERVER_URL}/get_signed_url?filename=${filename}`;
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await fetch(apiUrl, options);
      const data = await response.json();
      return data.signed_url || null;
    } catch (error) {
      console.error('Error fetching signed URL:', error);
      return null;
    }
  };

  // Sign many files in one request. Falls back to per-file signing if the
  // batch endpoint is unavailable, so this is safe against an older backend.
  const fetchSignedUrls = async (filenames) => {
    const wanted = [...new Set((filenames || []).filter(Boolean))];
    if (wanted.length === 0) return {};

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get_signed_urls`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filenames: wanted }),
      });
      if (response.ok) {
        const data = await response.json();
        if (data && data.signed_urls) return data.signed_urls;
      }
    } catch (error) {
      console.warn('Batch signing unavailable, falling back to per-file:', error);
    }

    const results = await Promise.all(
      wanted.map(async (f) => [f, await fetchSignedUrl(f)])
    );
    return results.reduce((acc, [f, url]) => ({ ...acc, [f]: url }), {});
  };

  const fetchImageUrls = async (assessment) => {
    setLoadingImages(true);
    try {
      if (Array.isArray(assessment?.proct_images) && assessment.proct_images.length > 0) {
        const currentDate = new Date();
        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(currentDate.getMonth() - 6);
  
        const validImages = assessment.proct_images.filter((image) => {
          const uploadedOn = new Date(image?.proct_image_uploaded_on);
          return uploadedOn > sixMonthsAgo;
        });
  
        if (validImages.length === 0) {
          const message = 'Camera shots will be automatically deleted after 6 months and not available.';
          setImageUrls({ message });
          return { message };
        }
  
        // Sign every snapshot in one call. This used to be a sequential await
        // per image, which is why pages with many snapshots took so long.
        const usableImages = validImages.filter(
          (image) => image?.proct_image_url && image?.proct_image_uploaded_on
        );
        const signedMap = await fetchSignedUrls(
          usableImages.map((image) => image.proct_image_url)
        );

        const signedImageData = usableImages
          .filter((image) => signedMap[image.proct_image_url])
          .map((image) => ({
            url: signedMap[image.proct_image_url],
            timestamp: image.proct_image_uploaded_on,
          }));


        setImageUrls(signedImageData);
        return signedImageData;
      } else {
        setImageUrls({ message: 'No camera snapshots available.' });
        return { message: 'No camera snapshots available.' };
      }
    } catch (error) {
      console.error('Error in fetchImageUrls:', error);
      setImageUrls({ message: 'Failed to load camera snapshots.' });
      return { message: 'Failed to load camera snapshots.' };
    } finally {
      setLoadingImages(false);
    }
  };

  const fetchAllAudioUrls = async (assessment) => {
    const audioFields = [
      "speaking_intro_audio_url",
      "speaking_topic_audio_url",
      "speaking_interaction_audio_url",
      "audio_url",
    ];

    // Also include any audio_scenario_*_audio_url fields
    Object.keys(assessment).forEach(key => {
      if (key.startsWith("audio_scenario_") && key.endsWith("_audio_url") && !audioFields.includes(key)) {
        audioFields.push(key);
      }
    });

    // Sign every recording in a single request instead of one call per file
    const presentFields = audioFields.filter((field) => assessment[field]);
    const signedMap = await fetchSignedUrls(presentFields.map((field) => assessment[field]));

    const signedUrls = presentFields.reduce((acc, field) => {
      const url = signedMap[assessment[field]];
      return url ? { ...acc, [field]: url } : acc;
    }, {});
    setAudioUrls(signedUrls);
  };

  const fetchAndClear = async (assessment) => {
    setAudioUrls({});
    setLoadingAudios(true);
    try {
      await fetchAllAudioUrls(assessment);
    } finally {
      // Always stop the spinner once signing has finished, whatever came back.
      // Previously this was inferred from the shape of the result, so a candidate
      // who only part-completed the speaking or reading sections left the
      // recordings tab spinning forever.
      setLoadingAudios(false);
    }
  };

  const fetchAndClearImage = async (assessment) => {
    setImageUrls(null);
    await fetchImageUrls(assessment);
  };

  // const reload_transcribe = async () => {
  //   const formData = new FormData();
  //   formData.append("url", assessment.audioUrl);
  //   formData.append("assessment_uid", assessment.uid);
  //   formData.append("passage", assessment.passage);
  //   formData.append("user_id", assessment.userId);
  //   fetch(process.env.REACT_APP_SERVER_URL + "/reload_transcribe", {
  //     method: "POST",
  //     body: formData,
  //     agent: new https.Agent({
  //       rejectUnauthorized: false,
  //       requestCert: false,
  //       agent: false,
  //     }),
  //   });
  // };

  const formatTime = (minutes, seconds) => {
    return parseInt(minutes) > 0
      ? `${minutes} mins ${seconds} secs`
      : `${seconds} secs`;
  };

  // const setTestTimes = (assessment1, updatedMapping) => {
  //   if (assessment1.started_time) {
  //     const timeData = {};
  //     const startDate = new Date(0);
  //     startDate.setUTCSeconds(assessment1.started_time.seconds);
  //     timeData["BEGIN_TEST"] = startDate;
  //     let steps1 = assessment1.steps;
  //     steps1.forEach((step, index) => {
  //       if (step === "BEGIN_TEST") return;

  //       const previousStepDate = timeData[steps1[index - 1]] || startDate;
  //       const stepDate = new Date(0);
  //       const obj = updatedMapping[step]
  //       try {
  //         stepDate.setUTCSeconds(obj['time']?.seconds);
  //       } catch (error) {
  //         return
  //       }
        
  //       const deltaTime = Math.abs(stepDate - previousStepDate);

  //       timeData[step] = stepDate;

  //       const minutes = Math.floor(deltaTime / 1000 / 60);
  //       const seconds = Math.floor((deltaTime / 1000) % 60);

  //       switch (step) {
          
  //         case "Vocabulary":
  //           setGrammerTime(formatTime(minutes, seconds));
  //           break;
  //         case "aptitude":
  //           setAptitudeTime(formatTime(minutes, seconds));
  //           break;
  //         case "aptitude_technical":
  //           setAptitudeTechnicalTime(formatTime(minutes, seconds));
  //           break;
  //         case "sales_retention":
  //           setSalesRetentionTime(formatTime(minutes, seconds));
  //           break;  
  //         case "comprehensive":
  //           setComprehensiveTime(formatTime(minutes, seconds));
  //           break;
  //         case "emotional_intelligence":
  //           setEmotionalIntelligenceTime(formatTime(minutes, seconds));
  //           break;
  //         case "call_center_knowledge":
  //           setCallCenterKnowledgeTime(formatTime(minutes, seconds));
  //           break;
  //         case "customer_service":
  //           setCustomerServiceTime(formatTime(minutes, seconds));
  //           break;
  //         case "tech_support":
  //           setTechSupportTime(formatTime(minutes, seconds));
  //           break;   
  //         case "sales":
  //           setSalesTime(formatTime(minutes, seconds));
  //           break;
  //         case "attention":
  //           setAttentionTime(formatTime(minutes, seconds));
  //           break;
  //         case "reading":
  //           setRecordingTime(formatTime(minutes, seconds));
  //           break;
  //         case "listening":
  //           setListeningTime(formatTime(minutes, seconds));
  //           break;
  //         case "cefr_reading":
  //           setCefrReadingTime(formatTime(minutes, seconds));
  //           break;
  //         case "cefr_listening":
  //           setCefrListeningTime(formatTime(minutes, seconds));
  //           break;
  //         case "cefr_writing":
  //           setCefrWritingTime(formatTime(minutes, seconds));
  //           break;
  //         case "speaking_interaction":
  //           setCefrSpeakingInteractionTime(formatTime(minutes, seconds));
  //           break;
  //         case "speaking_topic":
  //           setCefrSpeakingTopicTime(formatTime(minutes, seconds));
  //           break;
  //         case "speaking_intro":
  //           setCefrSpeakingIntroTime(formatTime(minutes, seconds));
  //           break;
  //         case "retention_listening":
  //           setRetentionListeningTime(formatTime(minutes, seconds));
  //           break;
  //         case "altice_question":
  //           setAlticeQuestionsTime(formatTime(minutes, seconds));
  //           break;
  //         case "integrity":
  //           setIntegrityTime(formatTime(minutes, seconds));
  //           break;
  //         case "attendance":
  //           setAttendanceTime(formatTime(minutes, seconds));
  //           break;
  //         default:
  //           break;
  //       }
  //     });

  //     const firstStep = startDate;
  //     const lastStepIndex = steps1.indexOf("Finish") - 1;
  //     const lastStep = steps1[lastStepIndex];
  //     const lastStepTime = timeData[lastStep];
  //     const overallTime = Math.abs(lastStepTime - firstStep);
  //     const overAllMinutes = Math.floor(overallTime / 1000 / 60);
  //     const overAllSeconds = Math.floor((overallTime / 1000) % 60);
  //     setStartTime(formatTime(overAllMinutes, overAllSeconds));
  //   }
  // };

  const getPreviousAssessments = () => {
    if (assessments && assessments.length > 0) {
      return (
        <>
          <SoftBox pt={2} mb={1}>
            <SoftTypography variant="body1" style={{color: "#4F4F4F", fontSize: "24px", fontWeight: "700"}}>
              Candidate Test
            </SoftTypography>
          </SoftBox>

          <Card pt={3} sx={{borderRadius: "10px"}}>
            <SoftBox pt={1} pb={2} px={2}>
              <SoftBox
                component="ul"
                display="flex"
                flexDirection="column"
                p={0}
                m={0}
              >
              {assessments.map((assessment2) => {
                const filteredRegion = regions.filter(region => region.region === assessment2.region);
                const isSelected = assessment2.uid === assessment.uid;
                const test_name = assessment2.test_name;
                const detailed_test_name = filteredRegion[0]?.tests[test_name]?.Name;
                if(assessment2.region) {
                  return (
                    <SoftBox
                      component="li"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      borderRadius="lg"
                      p={1}
                      mb={0}
                    >
                      <SoftTypography variant="body2" color="text.secondary">
                        <StyledLink
                          isSelected={isSelected}
                          onClick={() => handleSetAssessment(assessment2)}
                        >
                          {detailed_test_name} {" - "} {getDateStr(assessment2)}
                        </StyledLink>
                      </SoftTypography>
                    </SoftBox>
                  )}
              })}
              </SoftBox>
            </SoftBox>
          </Card>
        </>
      );
    } else return <></>;
  };

  const handleNext = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "component_loaded",
        component: steps[activeStep + 1],
      },
    });
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "component_loaded",
        component: steps[activeStep - 1],
      },
    });
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepsNavigation = (assessment2) =>{
    const stepsArray = [SCREENING];
    const stepsData = assessment2.steps || [];
    if (stepsData.includes("reading")) {
      stepsArray.push(REVIEW_RECORDING);
    }

    if (stepsData.some(step => step.startsWith("speaking_") || step.startsWith("audio_scenario_"))) {
      stepsArray.push(REVIEW_SPEAKING);
    }

    if (stepsData.some(step => !["begin_test", "finish", "reading", "listening"].includes(step))) {
      stepsArray.push(REVIEW_QUESTIONS);
    }

    if (stepsData.includes("cefr_writing")) {
      stepsArray.push(REVIEW_WRITING);
    }

    if (stepsData.includes("listening") || stepsData.includes("cefr_listening")) {
      stepsArray.push(REVIEW_LISTENING);
    }

    stepsArray.push(FEEDBACK);
    setSteps(stepsArray);
  }

  const gradeOptions = [
    { value: "poor", label: "Poor", score: 0 },
    { value: "below_average", label: "Below Average", score: 25 },
    { value: "average", label: "Average", score: 50 },
    { value: "good", label: "Good", score: 75 },
    { value: "excellent", label: "Excellent", score: 100 },
  ];

  const saveScenarioGrade = async (sectionKey) => {
    setScenarioGradeSaving(prev => ({ ...prev, [sectionKey]: true }));
    try {
      const grade = scenarioGrades[sectionKey] || "";
      const fb = scenarioFeedback[sectionKey] || "";
      const gradeObj = gradeOptions.find(g => g.value === grade);
      const recruiterScore = gradeObj ? gradeObj.score : null;
      const updateData = {
        [`${sectionKey}_recruiter_grade`]: grade,
        [`${sectionKey}_recruiter_feedback`]: fb,
        [`${sectionKey}_recruiter_score`]: recruiterScore,
        // Recruiter grade overrides ML score as final score
        [`${sectionKey}_score`]: recruiterScore != null ? recruiterScore : assessment[`${sectionKey}_score`],
      };
      await updateDoc(doc(collection(db, "assessments"), assessment.uid), updateData);
      // Update local assessment state so UI reflects the change
      setAssessment(prev => ({ ...prev, ...updateData }));
      console.log(`Saved recruiter grade for ${sectionKey}: ${grade} -> ${recruiterScore}%`);
    } catch (error) {
      console.error("Error saving scenario grade:", error);
    } finally {
      setScenarioGradeSaving(prev => ({ ...prev, [sectionKey]: false }));
    }
  };

  const handleSetAssessment = (assessment2) => {
    setErrorMessage('');
    // setTestTimes(assessment2);
    setAssessment(assessment2);
    handleStepsNavigation(assessment2)
    setFeedback(assessment2.feedback);

    setRecruiterOutcome(assessment2.recruiter_outcome || "");
    setSelectedReasons(assessment2.selected_reasons || []);
    setCefrScoreRecruiter(assessment2.cefr_score_recruiter || "");
    // Load scenario recruiter grades and feedback
    const grades2 = {};
    const fbk2 = {};
    Object.keys(assessment2).forEach(key => {
      if (key.startsWith("audio_scenario_") && key.endsWith("_recruiter_grade")) {
        grades2[key.replace("_recruiter_grade", "")] = assessment2[key];
      }
      if (key.startsWith("audio_scenario_") && key.endsWith("_recruiter_feedback")) {
        fbk2[key.replace("_recruiter_feedback", "")] = assessment2[key];
      }
    });
    setScenarioGrades(grades2);
    setScenarioFeedback(fbk2);

    setJobId(assessment2.job_id);
    setAudioUrl(assessment2.audioUrl);
    fetchAndClear(assessment2);
    fetchAndClearImage(assessment2)
    setIsLoading(false);
    setVocabText(assessment2.vocabtext || []);
    if (assessment2.currentStep) {
      setTestStatus(assessment2.currentStep);
    }
    if (assessment2.listeningAnswer) {
      const groupedAnswers = assessment2.listeningAnswer.reduce((acc, curr) => {
        if (!acc[curr.audioFile]) {
          acc[curr.audioFile] = [];
        }
        acc[curr.audioFile].push(curr);
        return acc;
      }, {});
      const groupedAnswersArray = Object.entries(groupedAnswers).map(
        ([audioFile, answers]) => ({
          audioFile,
          answers,
        })
      );

      setListeningTestArray(groupedAnswersArray);
    }
  };

  const emailCode = async (isPass) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("recipient_email", user.email);
    formData.append("code", user.uid);
    formData.append("recipient_name", user.firstName + " " + user.lastName);
    const myvar = generateEmailBody(
      user,
      process.env.SITE_FE || "https://glowskills.gtuncommonapps.coms/",
      process.env.ORGANISATION || "UnifyCX"
    );
    const response = await fetch(
      process.env.REACT_APP_SERVER_URL + "/send_template",
      {
        method: "POST",
        body: formData,
        agent: new https.Agent({
          rejectUnauthorized: false,
          requestCert: false,
          agent: false,
        }),
      }
    );
    const result = await response.text();
    setIsLoading(false);
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
    }, 4000);
  };

  const handleEmailClick = () => {
    const recipientEmail = user.email;
    const subject = encodeURIComponent("Your Code from UnifyCX");
  
    const htmlContent = generateOutEmailBody(
      user,
      process.env.SITE_FE || "https://glowskills.gtuncommonapps.com/", 
      process.env.ORGANISATION || "UnifyCX"
    );
    
    const encodedHtmlContent = encodeURIComponent(htmlContent);
    const outlookUrl = `https://outlook.office.com/mail/deeplink/compose?to=${recipientEmail}&subject=${subject}&body=${encodedHtmlContent}`;
    window.open(outlookUrl, '_blank');
  };

  const handleFeedback = () => {
    const currentUserEmail = auth?.currentUser?.email || localStorage.getItem('email');
    // if (!currentUserEmail) {
    //   console.warn("No current user email. Logging out.");
    //   handleLogout();
    //   return;
    // }

    const hasCefrOrSpeaking = assessment?.steps?.some(
      step => step.startsWith("cefr_") || step.startsWith("speaking_") || step.startsWith("audio_scenario_")
    );
    const noShowCefr =
      assessment?.test_name === "old" ||
      assessment?.test_name === "all" ||
      !hasCefrOrSpeaking;
      
    setTimeout(() => {
      setValidationError("");
    }, 5000);

    if (!jobId?.trim()) {
      setValidationError("Please enter Job ID");
      return;
    }
  
    if (!recruiterOutcome) {
      setValidationError("Please select an assessment outcome");
      return;
    }
  
    if (!noShowCefr && !cefrScoreRecruiter) {
      setValidationError("Please select a CEFR score");
      return;
    }
  
    if (selectedReasons.length === 0) {
      setValidationError("Please select at least one reason");
      return;
    }
   
  
    // Clear errors before proceeding
    setValidationError("");
    setIsLoading(true);

    const isPass = recruiterOutcome === 'accept' ? true : false
    updateDoc(doc(collection(db, "assessments"), assessment.uid), {
      job_id: jobId ? jobId : "",
      feedback: feedback ? feedback : "",
      isPass: isPass,
      // resultStatus: isPass ? "Passed" : "Rejected",
      recruiter_outcome: recruiterOutcome,
      selected_reasons: selectedReasons,
      cefr_score_recruiter: cefrScoreRecruiter,
      feedbackAt: serverTimestamp(),
      feedbackBy: currentUserEmail
    })
      .then(() => {
        setIsLoading(false);
        setFeedbackSubmitted(true);
        setTimeout(() => {
          setFeedbackSubmitted(false);
        }, 5000);

        console.log("Updated feedback successfully");
      })
      .catch((error) => {
        console.error("Error feedback:", error);
      });

    updateDoc(doc(collection(db, "users"), assessment.userId), {
      isPass: recruiterOutcome,
      // resultStatus: isPass ? "Passed" : "Rejected",
      cefr_score_recruiter: cefrScoreRecruiter,
      lastUpdatedOn: serverTimestamp(),
      feedbackAt: serverTimestamp(),
      feedbackBy: user.email
    })
      .then(() => {
        console.log("Updated feedback successfully");
      })
      .catch((error) => {
        console.error("Error feedback:", error);
      });
  };


  const toggleCollapse = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const formatSecondsToMinSec = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.round(seconds % 60);
    return `${mins > 0 ? `${mins} min ` : ""}${secs} sec`;
  }; 

  useEffect(() => {
    if (assessment && audioUrls) {
      const timeout = setTimeout(() => setIsAudioLoading(false), 1000);
      return () => clearTimeout(timeout);
    }
  }, [assessment, audioUrls]);

  useEffect(() => {
    const hasSingleAudio = !!audioUrls?.audio_url;
    const hasSpeakingAudios =
      !!audioUrls?.speaking_intro_audio_url &&
      !!audioUrls?.speaking_topic_audio_url &&
      !!audioUrls?.speaking_interaction_audio_url;

    const hasOldAudioUrl = !!assessment?.audioUrl;

    // Check if assessment has any audio scenario URLs
    const hasAudioScenarioUrls = assessment && Object.keys(assessment).some(
      key => key.startsWith("audio_scenario_") && key.endsWith("_audio_url") && assessment[key]
    );

    // No speaking/recording sections at all — stop loading
    const stepsData = assessment?.steps || [];
    const hasSpeakingSteps = stepsData.some(step => step.startsWith("speaking_"));
    const hasReadingStep = stepsData.includes("reading");
    const noAudioSections = !hasSpeakingSteps && !hasReadingStep && !hasOldAudioUrl;

    if (hasSingleAudio || hasSpeakingAudios || hasOldAudioUrl || hasAudioScenarioUrls || noAudioSections) {
      setLoadingAudios(false);
    }
  }, [audioUrls, assessment]);  
  
  const getLoader = () => (
    <RotatingLines
      strokeColor="black"
      strokeWidth="5"
      animationDuration="0.75"
      width="96"
      visible={true}
    />
  );

  const getQuestionsPage = (isPdf) => {
    if (assessment) {
      return (
        <Container style={{ marginBottom: "40px" }}>
          {sectionKeyMapping.map((item) => {
            // let sectionHeader = section_header.find((section) => section.key === label)?.value || "Unknown Section";
            let sectionHeader = item.heading
            const section = sectionKeyMapping.find((section) => section.key === item.key);
            if (["listening", "cefr_listening", "retention_listening", "speaking_intro",
              "speaking_topic", "speaking_interaction", "cefr_writing", "b2b_sales_listening",
              "sales_enablement_listening", "upselling_cs_listening"
            ].includes(item.key) || item.key.startsWith("audio_scenario_")) {
              return null;
            }
            // if (item.key.contains('_speaking'))
            if (item.key === "cefr_reading" && assessment.test_name === "altice_retention_support") {
              sectionHeader = "Grammar";
            }
            const sectionData = section?.value || [];
            const sectionScore = section?.score || null;
            const sectionTime = section?.time || null;
            const isCollapsed = collapsedSections[item.key];

            const sectionTotalQuestions = sectionData.reduce((acc, vocab) => {

              if (
                (vocab.category === "short_reading" && Array.isArray(vocab.questions)) ||
                (vocab.category === "attendance" && Array.isArray(vocab.questions)) ||
                (vocab.category === "attendance_es" && Array.isArray(vocab.questions)) ||
                (vocab.category === "retention_questions" && Array.isArray(vocab.questions)) ||
                (vocab.category === "chat_scenario" && Array.isArray(vocab.questions))
              ) {
                return acc + vocab.questions.length;
              }
              return acc + 1;
            }, 0);
            
            let sectionQuestionNumber = 1; // Local to section

            return (
              sectionScore &&
              sectionTime && 
              (
                <SoftBox pt={2} pb={4} key={item.key}>
                  <SoftTypography
                    variant="body2"
                    color="dark"
                    onClick={() => toggleCollapse(item.key)}
                    style={{ color: "#4F4F4F", cursor: "pointer", fontSize: "24px", fontWeight: "700", marginBottom: "10px" }}
                  >
                    {sectionHeader} {isCollapsed ? "▼" : "▲"}
                  </SoftTypography>  
                  {(!isCollapsed || forceExpandForPDF) && (
                    <SoftBox pt={1}>
                      {sectionScore !== null && item.key !== "cefr_reading" && (
                        <SoftTypography variant="h6" color="dark">
                          <span style={{ color: "#9D9D9D", fontSize: "16px", fontWeight: "600" }}>Score: </span>
                          <span style={{ color: "#4F4F4F", fontSize: "16px", fontWeight: "600" }}>
                            {sectionScore ? `${parseFloat(sectionScore).toFixed(2)} %` : "--"}
                          </span>
                        </SoftTypography>
                      )}
                      {sectionTime !== null && (
                        <SoftTypography variant="h6" color="dark" style={{ marginBottom: "20px" }}>
                          <span style={{ color: "#9D9D9D", fontSize: "16px", fontWeight: "600" }}>Time: </span>
                          <span style={{ color: "#4F4F4F", fontSize: "16px", fontWeight: "600" }}>{sectionTime}</span>
                        </SoftTypography>
                      )}
                      {sectionData.length > 0 ? (
                        sectionData.map((vocab, index) => {
                          
                          const questionCount =
                            (vocab.category === "short_reading" && Array.isArray(vocab.questions)) ||
                            (vocab.category === "retention_questions" && Array.isArray(vocab.questions)) ||
                            (vocab.category === "attendance_es" && Array.isArray(vocab.questions)) ||
                            (vocab.category === "attendance" && Array.isArray(vocab.questions)) ||
                            (vocab.category === "chat_scenario" && Array.isArray(vocab.questions))
                              ? vocab.questions.length
                              : 1;
  
                          const card = (
                            <VocabCard
                              key={index}
                              vocab={vocab}
                              sectionQuestionNumber={sectionQuestionNumber}
                              sectionTotalQuestions={sectionTotalQuestions}
                            />
                          );
  
                          sectionQuestionNumber += questionCount; 
                          return card;
                        })
                      ) : (
                        <SoftTypography variant="h6" fontWeight="medium" color="dark">
                          No answers found for this section.
                        </SoftTypography>
                      )}
                    </SoftBox>
                  )}
                </SoftBox>
              )
            );
          })}
        </Container>
      );
    }
  };

  const getListeningPage = (isPdf) => {
    if (!assessment) return;
  
    const listeningSections = [];
    if (assessment.listening) listeningSections.push({ key: "listening", sourceType: "listening" });
    if (assessment.cefr_listening) listeningSections.push({ key: "cefr_listening", sourceType: "cefr_listening" });
    if (assessment.retention_listening) listeningSections.push({ key: "retention_listening", sourceType: "retention_listening" });
    
    if (assessment.b2b_sales_listening) listeningSections.push({ key: "b2b_sales_listening", sourceType: "b2b_sales_listening" });
    if (assessment.upselling_cs_listening) listeningSections.push({ key: "upselling_cs_listening", sourceType: "upselling_cs_listening" });
    if (assessment.sales_enablement_listening) listeningSections.push({ key: "sales_enablement_listening", sourceType: "sales_enablement_listening" });


    if (assessment.listeningAnswer) listeningSections.push({ key: "listeningAnswer", sourceType: "listeningAnswer" });
  
    const relevantSections = listeningSections
      .map(({ key, sourceType }) => {
        const sectionData = sectionKeyMapping.find((section) => section.key === key);
        return sectionData ? { ...sectionData, sourceType } : null;
      })
      .filter(Boolean);
    return (
      <Container style={{ marginBottom: "40px" }}>
        {relevantSections.map((section) => {
          const sectionHeader = section?.heading
          const sectionData = section?.value || [];
          const sectionScore = section?.score || null;
          const sectionTime = section?.time || null;

          const isCollapsed = collapsedSections[section.key];
  
          const normalizedData = sectionData[0]?.questions
            ? sectionData
            : [
                {
                  audio_url: sectionData[0]?.audioFile || "",
                  questions: sectionData.map((item) => ({
                    question: item.question,
                    correct_answer: item.correct_answer,
                    answer: item.answer,
                  })),
                },
              ];
  
          const sectionTotalQuestions = normalizedData.reduce((acc, item) => {
            return acc + (item?.questions?.length || 0);
          }, 0);
          let sectionQuestionNumber = 1;
  
          return (
            <SoftBox pt={2} pb={4} key={section.key}>
              <SoftTypography
                variant="body2"
                color="dark"
                onClick={() => toggleCollapse(section.key)}
                style={{
                  color: "#4F4F4F",
                  cursor: "pointer",
                  fontSize: "24px",
                  fontWeight: "700",
                  marginBottom: "10px",
                }}
              >
                {sectionHeader} {isCollapsed ? "▼" : "▲"}
              </SoftTypography>
  
              {(!isCollapsed || forceExpandForPDF) && (
                <SoftBox pt={1}>
                  {sectionScore !== null && section?.key !== "cefr_listening" && (
                    <SoftTypography variant="h6" color="dark">
                      <span style={{ color: "#9D9D9D", fontSize: "16px", fontWeight: "600" }}>
                        Score:{" "}
                      </span>
                      <span style={{ color: "#4F4F4F", fontSize: "16px", fontWeight: "600" }}>
                        {sectionScore ? `${parseFloat(sectionScore).toFixed(2)} %` : "--"}
                      </span>
                    </SoftTypography>
                  )}
                  {sectionTime !== null && (
                    <SoftTypography variant="h6" color="dark" style={{ marginBottom: "20px" }}>
                      <span style={{ color: "#9D9D9D", fontSize: "16px", fontWeight: "600" }}>
                        Time:{" "}
                      </span>
                      <span style={{ color: "#4F4F4F", fontSize: "16px", fontWeight: "600" }}>
                        {sectionTime}
                      </span>
                    </SoftTypography>
                  )}
  
                  {normalizedData.length > 0 ? (
                    normalizedData.map((audioObj, index) => (
                      <SoftBox key={index} pt={3}>
                        {audioObj.audio_url && (
                          <AudioWrapper
                            style={{ backgroundColor: "white", padding: "25px 5px 25px 20px" }}
                          >
                            <audio
                              controls
                              src={
                                (section?.sourceType === "listeningAnswer"
                                  ? process.env.SITE_FE || "https://glowskills.gtuncommonapps.com/"
                                  : process.env.REACT_APP_STATIC_REPO
                                ).replace(/\/+$/, '') + // Remove trailing slash from base URL
                                '/' +
                                (audioObj?.audio_url || '').replace(/^\/+/, '') // Remove leading slash from audio path
                              }
                              onLoadedData={() =>
                                updateMediaStatus({
                                  listeningLoaded: mediaStatusRef.current.listeningLoaded + 1,
                                })
                              }
                            />
                          </AudioWrapper>
                        )}
  
                        <SoftBox pt={2}>
                          {audioObj?.questions?.map((question, qIndex) => {
                            const card = (
                              <VocabCard
                                key={qIndex}
                                vocab={question}
                                sectionQuestionNumber={sectionQuestionNumber}
                                sectionTotalQuestions={sectionTotalQuestions}
                              />
                            );
                            sectionQuestionNumber++;
                            return card;
                          })}
                        </SoftBox>
                      </SoftBox>
                    ))
                  ) : (
                    <SoftTypography variant="h6" fontWeight="medium" color="dark">
                      No answers found for this section.
                    </SoftTypography>
                  )}
                </SoftBox>
              )}
            </SoftBox>
          );
        })}
      </Container>
    );
  };  

  const getWritingPage = (isPdf) => {
    if (!assessment) return;
  
    const writingSection = sectionKeyMapping.find((section) => section.key === "cefr_writing");
    if (!writingSection) return null;
  
    const sectionHeader = section_header.find((s) => s.key === "cefr_writing")?.value || "Writing Section";
    const sectionData = writingSection?.value || [];
    const sectionScore = writingSection?.score || null;
    const sectionTime = writingSection?.time || null;
  
    const sectionTotalQuestions = sectionData.length;
    let sectionQuestionNumber = 1;
  
    return (
      <Container style={{ marginBottom: "40px" }}>
        <SoftBox pt={2} pb={4} key="cefr_writing">
          <SoftTypography
            variant="body2"
            color="dark"
            style={{color: "#4F4F4F", cursor: "pointer", fontSize: "24px", fontWeight: "700", marginBottom: "10px" }}
          >
            {sectionHeader}
          </SoftTypography>
  
          <SoftBox pt={1}>
            {sectionScore !== null && sectionScore !== 0 && (() => {
              const numScore = parseFloat(sectionScore);
              const grade = numScore > 87.5 ? "Excellent" : numScore > 62.5 ? "Good" : numScore > 37.5 ? "Average" : numScore > 12.5 ? "Below Average" : "Poor";
              const gradeColor = numScore > 87.5 ? "#2e7d32" : numScore > 62.5 ? "#1976d2" : numScore > 37.5 ? "#ed6c02" : numScore > 12.5 ? "#e65100" : "#d32f2f";
              return (
                <SoftTypography variant="h6" color="dark" style={{ marginBottom: "8px" }}>
                  <span style={{ color: "#9D9D9D", fontSize: "16px", fontWeight: "600" }}>Score: </span>
                  <span style={{ fontSize: "16px", fontWeight: "700", color: gradeColor }}>{numScore.toFixed(1)}%</span>
                  <span style={{ fontWeight: "400", color: "#9D9D9D", marginLeft: "8px", fontSize: "14px" }}>({grade})</span>
                </SoftTypography>
              );
            })()}
            {sectionTime !== null && (
              <SoftTypography variant="h6" color="dark" style={{ marginBottom: "20px" }}>
                <span style={{ color: "#9D9D9D", fontSize: "16px", fontWeight: "600" }}>Time:{" "}</span>
                <span style={{ color: "#4F4F4F", fontSize: "16px", fontWeight: "600" }}>
                  {sectionTime}
                </span>
              </SoftTypography>
            )}
  
            {sectionData.length > 0 ? (
              sectionData.map((vocab, index) => {
                // Map writing question index to feedback key
                const writingFeedbackKeys = ["writing_short_feed_back", "writing_structured_feed_back"];
                const writingScoreKeys = ["writing_short", "writing_structured"];
                const feedbackKey = writingFeedbackKeys[index];
                const scoreKey = writingScoreKeys[index];
                const writingFeedback = feedbackKey ? assessment?.[feedbackKey] : null;

                // Get the individual ML score for this writing question
                const writingScoreValue = scoreKey ? assessment?.[scoreKey + "_score"] : null;
                const mlScore = writingScoreValue != null ? parseFloat(writingScoreValue) : null;
                const mlGrade = mlScore != null
                  ? (mlScore > 87.5 ? "Excellent" : mlScore > 62.5 ? "Good" : mlScore > 37.5 ? "Average" : mlScore > 12.5 ? "Below Average" : "Poor")
                  : null;
                const mlColor = mlScore != null
                  ? (mlScore > 87.5 ? "#2e7d32" : mlScore > 62.5 ? "#1976d2" : mlScore > 37.5 ? "#ed6c02" : mlScore > 12.5 ? "#e65100" : "#d32f2f")
                  : "#4F4F4F";

                const card = (
                  <div key={index}>
                    <VocabCard
                      vocab={vocab}
                      sectionQuestionNumber={sectionQuestionNumber}
                      sectionTotalQuestions={sectionTotalQuestions}
                    />
                    {/* ML Score + Feedback for writing section (read-only) */}
                    {(mlScore != null || writingFeedback) && (
                      <SoftBox mb={2} mx={0} p={2} style={{ backgroundColor: "#F5F5F5", borderRadius: "8px", marginTop: "-8px" }}>
                        {mlScore != null && (
                          <SoftTypography variant="body2" style={{ fontSize: "16px", fontWeight: "600", color: "#4F4F4F", marginBottom: "8px" }}>
                            ML Score: <span style={{ fontWeight: "700", color: mlColor }}>{mlScore.toFixed(1)}%</span>
                            <span style={{ fontWeight: "400", color: "#9D9D9D", marginLeft: "8px" }}>({mlGrade})</span>
                          </SoftTypography>
                        )}
                        {writingFeedback && (
                          <>
                            <SoftTypography variant="body2" style={{ fontSize: "14px", fontWeight: "600", color: "#4F4F4F", marginBottom: "4px" }}>
                              ML Feedback:
                            </SoftTypography>
                            <SoftTypography variant="body2" style={{ fontSize: "14px", fontWeight: "400", color: "#666", lineHeight: "1.6", whiteSpace: "pre-line" }}>
                              {writingFeedback}
                            </SoftTypography>
                          </>
                        )}
                      </SoftBox>
                    )}
                  </div>
                );
                sectionQuestionNumber++;
                return card;
              })
            ) : (
              <SoftTypography variant="h6" fontWeight="medium" color="dark">
                No answers found for this section.
              </SoftTypography>
            )}
          </SoftBox>
        </SoftBox>
      </Container>
    );
  };

  const getReviewRecordingPage = (isPdf) => {

    if (!assessment || (!assessment.audioUrl && !audioUrls) || loadingAudios) {
      return (
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" py={5} margin="auto">
          {getLoader()}
          <SoftTypography variant="button" color="text" fontWeight="regular" mt={2}>
            Preparing secure playback links&hellip;
          </SoftTypography>
          <SoftTypography variant="caption" color="secondary" mt={0.5}>
            Recordings are private and signed on demand. This can take a few seconds.
          </SoftTypography>
        </SoftBox>
      );
    }
    
    let filteredAudioUrls = [];
    let score = "--";
    let time = "--";
    const isCEFR = !assessment?.audioUrl && !audioUrls?.audio_url;
    if (assessment?.audioUrl) {
      filteredAudioUrls = [assessment.audioUrl];
      score = assessment.hasOwnProperty("reading_similarity") ? `${assessment.reading_similarity} %` : "--";
      time = typeof recordingTime !== "undefined" ? recordingTime : "--";
  
    } else if (audioUrls?.audio_url) {
      filteredAudioUrls = [audioUrls.audio_url];
      score = assessment.hasOwnProperty("reading_similarity") ? `${assessment.reading_similarity} %` : "--";
      time = typeof recordingTime !== "undefined" ? recordingTime : "--";
  
    } else {
      // Collect CEFR speaking URLs if present
      const cefrSpeakingUrls = [
        audioUrls?.speaking_intro_audio_url,
        audioUrls?.speaking_topic_audio_url,
        audioUrls?.speaking_interaction_audio_url,
      ].filter(Boolean);

      // Collect audio scenario signed URLs (not raw filenames from assessment)
      const audioScenarioKeys = Object.keys(assessment || {})
        .filter(key => key.startsWith("audio_scenario_") && key.endsWith("_audio_url") && assessment[key]);
      const audioScenarioUrls = audioScenarioKeys.map(key => audioUrls[key]).filter(Boolean);

      filteredAudioUrls = [...cefrSpeakingUrls, ...audioScenarioUrls];

      if (filteredAudioUrls.length > 0) {
        const introSection = sectionKeyMapping.find((section) => section.key === 'speaking_intro');
        const topicSection = sectionKeyMapping.find((section) => section.key === 'speaking_topic');
        const interactionSection = sectionKeyMapping.find((section) => section.key === 'speaking_interaction');

        const getTotalSeconds = (section) => {
          if (!section) return 0;
          return (section.minutes || 0) * 60 + (section.seconds || 0);
        };
        const totalSeconds =
              getTotalSeconds(introSection) +
              getTotalSeconds(topicSection) +
              getTotalSeconds(interactionSection);

        if (totalSeconds > 0) {
          time = formatSecondsToMinSec(totalSeconds);
        }

        const introScore = assessment?.speaking_intro_score ?? null;
        const topicScore = assessment?.speaking_topic_score ?? null;
        const interactionScore = assessment?.speaking_interaction_score ?? null;
        if (introScore !== null && topicScore !== null && interactionScore !== null) {
          const totalWeightedScore = introScore * 2 + topicScore * 4 + interactionScore * 4;
          const weightedAverage = totalWeightedScore / 10;
          score = weightedAverage.toFixed(2);
        } else {
          score = "--";
        }
      }
    }
  
    return (
      <>
        <SoftBox pt={1} pb={2}>
          <SoftBox pt={3}>
            <SoftTypography
              variant="body1"
              style={{ color: "#4F4F4F", cursor: "pointer", fontSize: "24px", fontWeight: "700", marginBottom: "10px" }}
            >
              {filteredAudioUrls.length > 1 ? "Speaking" : "Recordings"}
            </SoftTypography>
  
            {score !== "--" && (() => {
              const numScore = parseFloat(score);
              const grade = numScore > 87.5 ? "Excellent" : numScore > 62.5 ? "Good" : numScore > 37.5 ? "Average" : numScore > 12.5 ? "Below Average" : "Poor";
              const gradeColor = numScore > 87.5 ? "#2e7d32" : numScore > 62.5 ? "#1976d2" : numScore > 37.5 ? "#ed6c02" : numScore > 12.5 ? "#e65100" : "#d32f2f";
              return (
                <SoftTypography variant="h6" color="dark">
                  <span style={{ color: "#9D9D9D", fontSize: "16px", fontWeight: "600" }}>Score: </span>
                  <span style={{ fontSize: "16px", fontWeight: "700", color: gradeColor }}>{numScore.toFixed(1)}%</span>
                  <span style={{ fontWeight: "400", color: "#9D9D9D", marginLeft: "8px", fontSize: "14px" }}>({grade})</span>
                </SoftTypography>
              );
            })()}
            <SoftTypography variant="h6" color="dark">
              <span style={{ color: "#9D9D9D", fontSize: "16px", fontWeight: "600" }}>Time: </span>
              <span style={{ color: "#4F4F4F", fontSize: "16px", fontWeight: "600" }}>{time}</span>
            </SoftTypography>
          </SoftBox>
  
          {filteredAudioUrls.length > 0 && (
            <SoftBox pt={3}>
              {filteredAudioUrls.map((audio, index) => {
                // Build dynamic section/transcribe keys for CEFR + audio scenarios
                const cefrKeys = ["speaking_intro", "speaking_topic", "speaking_interaction"]
                  .filter(k => audioUrls?.[k + "_audio_url"]);
                const scenarioKeys = Object.keys(assessment || {})
                  .filter(k => k.startsWith("audio_scenario_") && k.endsWith("_audio_url") && assessment[k])
                  .map(k => k.replace("_audio_url", ""));
                const allSectionKeys = [...cefrKeys, ...scenarioKeys];
                const sectionKey = allSectionKeys[index];
                const section = assessment?.[sectionKey]?.[0];
                const transcribeText = assessment?.[sectionKey + "_transcribe"];
  
                return (
                  <Card key={index} mb={2} variant="outlined" style={{ marginBottom: "1rem", boxShadow: "none", borderRadius: "8px" }}>
                    <SoftBox position="relative" sx={{ width: "100%", backgroundColor: "#EAEAEA", padding: "15px" }}>
                      {section?.question && (
                        <SoftTypography
                          variant="h6"
                          fontWeight="medium"
                          color="dark"
                          mb={1}
                          style={{ textAlign: "left", fontSize: "16px", fontWeight: "400", color: "#4F4F4F" }}
                          dangerouslySetInnerHTML={{ __html: section.question }}
                        />
                      )}
                      {section?.description && (
                        <SoftTypography
                          variant="body2"
                          color="text"
                          mb={1}
                          style={{ textAlign: "left", fontSize: "16px", fontWeight: "400", color: "#4F4F4F", paddingLeft: "20px" }}
                          dangerouslySetInnerHTML={{ __html: section.description }}
                        />
                      )}
                      <SoftTypography
                        variant="body2"
                        color="dark"
                        mb={1}
                        style={{ textAlign: "left", fontSize: "16px", fontWeight: "400", color: "#4F4F4F" }}
                      >
                        Q {index + 1} of {filteredAudioUrls.length}
                      </SoftTypography>
                    </SoftBox>
                    <AudioWrapper key={index} style={{ margin: "25px 5px 25px 20px" }}>
                      <audio controls src={audio} 
                        onLoadedData={() =>
                          updateMediaStatus({
                            speakingLoaded: mediaStatusRef.current.speakingLoaded + 1,
                          })
                        }
                      />
                    </AudioWrapper>
  
                    {transcribeText && (
                      <SoftBox px={2} pb={2}>
                        <SoftTypography
                          variant="body2"
                          color="dark"
                          mb={1}
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Transcribed Passage:
                        </SoftTypography>
                        <UserTranscribe style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.6" }}>
                          {transcribeText}
                        </UserTranscribe>
                      </SoftBox>
                    )}

                    {/* ML Score & Feedback — for speaking and audio scenario sections */}
                    {(sectionKey?.startsWith("audio_scenario_") || sectionKey?.startsWith("speaking_")) && (
                      <SoftBox px={2} pb={2}>
                        {/* ML Score as Grade + Percentage */}
                        {assessment?.[sectionKey + "_score"] != null && (() => {
                          const mlScore = parseFloat(assessment[sectionKey + "_score"]);
                          const mlGrade = mlScore > 87.5 ? "Excellent" : mlScore > 62.5 ? "Good" : mlScore > 37.5 ? "Average" : mlScore > 12.5 ? "Below Average" : "Poor";
                          const mlColor = mlScore > 87.5 ? "#2e7d32" : mlScore > 62.5 ? "#1976d2" : mlScore > 37.5 ? "#ed6c02" : mlScore > 12.5 ? "#e65100" : "#d32f2f";
                          return (
                            <SoftBox mb={1}>
                              <SoftTypography variant="body2" style={{ fontSize: "16px", fontWeight: "600", color: "#4F4F4F" }}>
                                ML Score: <span style={{ fontWeight: "700", color: mlColor }}>{mlScore.toFixed(1)}%</span>
                                <span style={{ fontWeight: "400", color: "#9D9D9D", marginLeft: "8px" }}>({mlGrade})</span>
                              </SoftTypography>
                            </SoftBox>
                          );
                        })()}

                        {/* ML Feedback */}
                        {assessment?.[sectionKey + "_feed_back"] && (
                          <SoftBox mb={2} p={2} style={{ backgroundColor: "#F5F5F5", borderRadius: "8px" }}>
                            <SoftTypography variant="body2" style={{ fontSize: "14px", fontWeight: "600", color: "#4F4F4F", marginBottom: "4px" }}>
                              ML Feedback:
                            </SoftTypography>
                            <SoftTypography variant="body2" style={{ fontSize: "14px", fontWeight: "400", color: "#666", lineHeight: "1.6", whiteSpace: "pre-line" }}>
                              {assessment[sectionKey + "_feed_back"]}
                            </SoftTypography>
                          </SoftBox>
                        )}

                        {/* Recruiter Grade & Feedback - only for audio scenarios */}
                        {sectionKey?.startsWith("audio_scenario_") && (
                          <>
                            <SoftBox mb={1} display="flex" flexDirection={isMobile ? "column" : "row"} gap={2}>
                              <SoftBox flex="1">
                                <SoftTypography variant="body2" style={{ fontSize: "14px", fontWeight: "600", color: "#4F4F4F", marginBottom: "8px" }}>
                                  Recruiter Grade:
                                </SoftTypography>
                                <select
                                  value={scenarioGrades[sectionKey] || ""}
                                  onChange={(e) => setScenarioGrades(prev => ({ ...prev, [sectionKey]: e.target.value }))}
                                  style={{
                                    width: "100%",
                                    padding: "10px 12px",
                                    fontSize: "14px",
                                    borderRadius: "8px",
                                    border: "1px solid #d2d6da",
                                    backgroundColor: "#F7F7F7",
                                    color: "#495057",
                                    outline: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <option value="">Select Grade</option>
                                  {gradeOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                  ))}
                                </select>
                              </SoftBox>
                              <SoftBox flex="2">
                                <SoftTypography variant="body2" style={{ fontSize: "14px", fontWeight: "600", color: "#4F4F4F", marginBottom: "8px" }}>
                                  Recruiter Feedback:
                                </SoftTypography>
                                <SoftInput
                                  placeholder="Add your feedback for this scenario..."
                                  multiline
                                  rows={2}
                                  variant="outlined"
                                  value={scenarioFeedback[sectionKey] || ""}
                                  onChange={(e) => setScenarioFeedback(prev => ({ ...prev, [sectionKey]: e.target.value }))}
                                />
                              </SoftBox>
                            </SoftBox>

                            {/* Save Button */}
                            <SoftBox mt={1} mb={1}>
                              <SoftButton
                                variant="contained"
                                color="gt_primary"
                                size="small"
                                onClick={() => saveScenarioGrade(sectionKey)}
                                disabled={scenarioGradeSaving[sectionKey]}
                              >
                                {scenarioGradeSaving[sectionKey] ? "Saving..." : "Save Grade"}
                              </SoftButton>
                            </SoftBox>
                          </>
                        )}
                      </SoftBox>
                    )}
                  </Card>
                );
              })}
            </SoftBox>
          )}
  
          {!isCEFR && filteredAudioUrls.length > 0 && assessment?.passage && (
            <Card variant="outlined">
              <SoftBox pt={3} px={2}>
                <SoftTypography
                  variant="body2"
                  color="dark"
                  mb={1}
                  style={{ fontSize: "16px", fontWeight: "600" }}
                >
                  Passage:
                </SoftTypography>
                <SoftTypography variant="body2" color="dark" mb={1}>
                  {assessment.passage}
                </SoftTypography>
  
                {assessment?.transcribe && (
                  <>
                    <SoftTypography
                      variant="body2"
                      color="dark"
                      mb={1}
                      style={{ fontSize: "16px", fontWeight: "600", marginTop: "25px" }}
                    >
                      Transcribed Passage:
                    </SoftTypography>
                    <UserTranscribe style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.6" }}>
                      {getDiffs(assessment.passage, assessment.transcribe).map((diff, index) => {
                        const [type, text] = diff;
                        const cleanedText = text.replace(/\s+/g, " ");
                        if (type === 0) return <span key={index} style={{ color: "#344767" }}>{cleanedText} </span>;
                        if (type === 1 || type === -1) return <span key={index} style={{ color: "red" }}>{cleanedText} </span>;
                        return null;
                      })}
                    </UserTranscribe>
                  </>
                )}
              </SoftBox>
            </Card>
          )}
        </SoftBox>
        <SoftBox pb={5} />
      </>
    );
  };
    
  const getScreeningPage = (isPdf) => {
    const canShowRecruiter = feedback || cefrScoreRecruiter || recruiterOutcome || selectedReasons.length > 0;
    return (
      <>
        {user && (
          <SoftBox pt={2} pb={2} style={{padding: "0 !important"}} sx={{padding: "0 !important"}}>
            {!isPdf && (
              <>
                <SoftButton
                  variant="text"
                  color="gt_primary"
                  onClick={(event) => handleExportClick()}
                  style={{
                    borderRadius: "8px",
                    border: "1px solid #163073",
                    backgroundColor: "#FFF",
                    color:"#163073",
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                    padding: "10px 20px",
                    marginTop: "10px",
                    textTransform: "none"
                  }}
                >
                  Export to PDF
                </SoftButton>
                {isExporting && (
                  <span className="spinner" style={{fontSize: "14px", fontWeight: "500", color: "#4F4F4F", marginLeft: "10px", position: "relative", top: "3px"}}>
                    Preparing PDF, please wait...
                  </span>
                )}
                {errorMessage && (
                  <span style={{ fontSize: "14px", fontWeight: "500", color: "red", marginLeft: "10px", position: "relative", top: "3px"}}>
                    {errorMessage}
                  </span>
                )}
                {failedSpokenSections.length > 0 && (
                  <SoftButton
                    variant="text"
                    color="gt_primary"
                    disabled={isRescoring}
                    onClick={handleRescoreClick}
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #B54708",
                      backgroundColor: "#FFF",
                      color: "#B54708",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "700",
                      padding: "10px 20px",
                      marginTop: "10px",
                      marginLeft: "10px",
                      textTransform: "none",
                    }}
                  >
                    {isRescoring
                      ? "Rescoring..."
                      : `Rescore ML (${failedSpokenSections.length} unscored)`}
                  </SoftButton>
                )}
                {rescoreMessage && (
                  <span style={{ fontSize: "14px", fontWeight: "500", color: "#4F4F4F", marginLeft: "10px", position: "relative", top: "3px" }}>
                    {rescoreMessage}
                  </span>
                )}
              </>
            )}
            {getCandidateInfo()}
            {getPreviousAssessments(assessments)}
            {assessment && assessment.currentStep === "Finish" ? (
              <>
              {getCandidateScores(false)}
                {canShowRecruiter && getRecruiterScores()}
              </>
            ) : (
              <div>
                {!isPdf && (
                  <SoftButton
                    variant="text"
                    color="gt_primary"
                    onClick={(event) => handleEmailClick()}
                  >
                    Email the Code
                  </SoftButton>
                )}
              </div>
            )}
            {getCameraSnapshotPage()}
          </SoftBox>
        )}
        <SoftBox pb={5} />
      </>
    );
  };

  const getReasons = (isEnabled, renderOnlySelected) => {
    const options = renderOnlySelected ? selectedReasons : reasonOptions;
    return (
      <SoftBox display="flex" flexWrap="wrap" gap={1.5} mt={0} px={2}>
        {options.map((reason) => (
          <ToggleButton
            key={reason}
            value={reason}
            selected={selectedReasons.includes(reason)}
            onClick={() => {
              if (!isEnabled) return; // Safety (though already disabled)
              setSelectedReasons((prev) =>
                prev.includes(reason)
                  ? prev.filter((r) => r !== reason)
                  : [...prev, reason]
              );
            }}
            sx={{
              px: 2,
              py: 1,
              borderRadius: "25px",
              border: selectedReasons.includes(reason) ? "none" : "1.5px solid rgba(0, 0, 0, 0.3)",
              fontWeight: 500,
              fontSize: "12px",
              textTransform: "capitalize",
              color: selectedReasons.includes(reason)
                ? "white !important"
                : "#333 !important",
              backgroundColor: selectedReasons.includes(reason)
                ? "#1A73E8 !important"
                : "#ffffff !important",
              // "&:hover": {
              //   backgroundColor: selectedReasons.includes(reason) ? "pink" : "blue", // lighter hover
              // },
              transition: "all 0.2s ease"
            }}
            
            
          >
            {reason}
          </ToggleButton>
        ))}
      </SoftBox>
    )
  }

  const getStar = () => {
    return (
      <Box component="span" sx={{ paddingLeft:"4px", fontSize:"16px",  color: "red" }}>
        *
      </Box>
    )
  }

  const getFeedbackPage = (isPdf) => {
    const hasCefrOrSpeaking = assessment?.steps?.some(
      step => step.startsWith("cefr_") || step.startsWith("speaking_") || step.startsWith("audio_scenario_")
    );
    
    const noShowCefr =
      assessment?.test_name === "old" ||
      assessment?.test_name === "all" ||
      !hasCefrOrSpeaking;
      

    if (assessment)
      return (
        <>

        <SoftBox display="flex" flexDirection="row" gap={2}>
        <SoftBox flex="0 0 35%" maxWidth="35%">
          {getCandidateScores(true)}
        </SoftBox>
        <div style={{ flex: 1 }}>
          {feedbackSubmitted && (
            <SoftBox
              mt={2}
              mb={2}
              textAlign="center"
              bgColor={feedbackPass ? "info" : "warning"}
            >
              <h6
                style={{
                  fontSize: ".8em",
                  color: "dark",
                  textAlign: "center",
                  fontWeight: 400,
                  transition: ".2s all",
                }}
              >
                Submitted
                {/* {feedbackPass ? "Candidate selected" : "Candidate rejected"} */}
              </h6>
            </SoftBox>
          )}
      
          <Card>
            {!isPdf ? (
              <SoftBox pt={1} pb={2}>
                <SoftTypography variant="caption" fontWeight="medium" pl={2}>
                  Add job ID 
                  {getStar()}
                </SoftTypography>
                
                <SoftBox p={2} pt={0}>
                  <SoftInput
                    placeholder="Job Id..."
                    multiline
                    rows={1}
                    variant="outlined"
                    value={jobId}
                    inputProps={{ maxLength: 30 }}
                    onChange={(event) => setJobId(event.target.value)}
                    // icon={{ component: "search", direction: "left" }}
                  />
                </SoftBox>
                <SoftBox 
                 sx={{
                  pl: 2,
                  pr: 1,
                  backgroundColor: "#f7f7f7",
                  borderRadius: "8px",
                  mt: 0,
                  mx: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  minHeight: "70px",
                  paddingBottom: "8px",
                  paddingRight: "12px"
                }}
                >
                  <SoftTypography variant="h5" fontWeight={600}
                    sx={{
                      textAlign: "left",
                      color: "#333333",
                      fontWeight: 600,
                      fontSize: "18px",
                      minWidth: "250px",
                      paddingTop: "6px"
                    }}
                  >
                    Assessment Outcome?
                  </SoftTypography>                   
                  <SoftBox display="flex" justifyContent="flex-end" gap={2} width="70%" mt={1}>
                    {outcomeOptions.map((option) => (
                      <ButtonBase
                        key={option.value}
                        onClick={() => handleOutcomeSelect(option.value)}
                        sx={{
                          px: 3,
                          py: 1,
                          border: "1.5px solid",
                          borderColor:
                            recruiterOutcome === option.value ? "#90CAF9" : "rgba(0,0,0,0.2)",
                          boxShadow: recruiterOutcome === option.value ? "0 0 2px rgba(144, 202, 249, 0.6)" : "none",
                          backgroundColor: "#ffffff",
                          borderRadius: "25px",
                          fontWeight: 500,
                          fontSize: "16px",
                          color: selected === option.value ? "#1976d2" : "#333",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          transition: "all 0.2s ease",
                        }}
                      >
                        {recruiterOutcome === option.value && (
                          <CheckIcon sx={{ fontSize: "24px !important", color: "#1976d2"}} />
                        )}
                        {option.label}
                      </ButtonBase>
                    ))}
                  </SoftBox>
                </SoftBox>

                {!noShowCefr && (<>
                  <SoftTypography variant="caption" fontWeight="medium" pt={1} pl={2}>
                    Recruiter assessed CEFR score {getStar()}
                  </SoftTypography> 

                  <FormControl
                    size="small"
                    sx={{
                      marginBottom: isMobile ? "8px" : "0",
                      width: "95%",
                      marginX: "1rem", 
                    }}
                  >
                    <Select
                      displayEmpty
                      value={cefrScoreRecruiter}
                      onChange={(event) => setCefrScoreRecruiter(event.target.value)}
                      width="100%"
                    
                      sx={{
                        width: "100%",
                        color: "#848484 !important",
                        fontWeight: "400",
                        fontSize: "1rem !important",
                        backgroundColor: "#F7F7F7 !important",
                        "& .MuiSelect-select": {
                          minWidth: "100%",
                        },
                      }}
                      
                    > 
                      {cefrScoreRecruiter && (<MenuItem value="">
                        Select CEFR Score
                      </MenuItem>)}
                      <MenuItem key="A1" value="A1">A1</MenuItem>
                      <MenuItem key="A2" value="A2">A2</MenuItem>
                      <MenuItem key="B1" value="B1">B1</MenuItem>
                      <MenuItem key="B2" value="B2">B2</MenuItem>
                      <MenuItem key="C1" value="C1">C1</MenuItem>
                      <MenuItem key="C2" value="C2">C2</MenuItem>
                    </Select>
                  </FormControl>
                </>)}
                {recruiterOutcome && (
                  <SoftBox>
                    <SoftTypography variant="caption" fontWeight="medium" pt={1} pb={0} pl={2}>
                      Select the reason {getStar()}
                    </SoftTypography>
                    {getReasons(true, false)}
                  </SoftBox>
                )}
                <SoftTypography variant="caption" fontWeight="medium" pl={2}>
                  Feedback
                </SoftTypography>
                <SoftBox p={2} pt={0} pb={0}>
                  <SoftInput
                    placeholder="Feedback..."
                    multiline
                    rows={12}
                    variant="outlined"
                    value={feedback}
                    onChange={(event) => setFeedback(event.target.value)}f
                  />
                </SoftBox>
                {validationError && (
                  <SoftBox
                  mt={2}
                  mb={2}
                  textAlign="center"
                  bgColor={feedbackPass ? "info" : "warning"}
                  >
                  <h6
                    style={{
                      fontSize: ".8em",
                      color: "dark",
                      textAlign: "center",
                      fontWeight: 400,
                      transition: ".2s all",
                    }}
                  >
                    {validationError}
                  </h6>
                  </SoftBox>
                )}
                <SoftBox
                  mt={1}
                  px={2}
                  mb={6}
                >
                </SoftBox>

                <SoftBox pb={5} />
              </SoftBox>
            ) : (
              <>{feedback} </>
            )}
          </Card>
          </div>
          </SoftBox>
        </>
      );
  };

  const renderStep2 = () => {
    const hasCefrOrSpeaking = assessment?.steps?.some(
      step => step.startsWith("cefr_") || step.startsWith("speaking_") || step.startsWith("audio_scenario_")
    );
    
    const noShowCefr =
      assessment?.test_name === "old" ||
      assessment?.test_name === "all" ||
      !hasCefrOrSpeaking;

    const hasValidationError =
      !jobId?.trim() ||
      !recruiterOutcome ||
      (!noShowCefr && !cefrScoreRecruiter) ||
      selectedReasons.length === 0;
    return (
      <div>
        <div>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{
              my: 4,
              maxWidth: "100%",
              padding: "0%",

              "& .MuiStepConnector-line": {
                borderColor: "#B5B5B5 !important",
                borderTopWidth: "3px !important",
              },
              "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line" : {
                borderColor: "#163073 !important",
                borderTopWidth: "3px !important",
              },
              "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line" : {
                borderColor: "#163073 !important",
                borderTopWidth: "3px !important",
              },

              // dot container (SVG)
              "& .MuiStepIcon-root": {
                width: "12px !important",
                height: "12px !important",
                color: "#B5B5B5 !important",
                borderColor: "#B5B5B5 !important",
                stroke: "#B5B5B5 !important",
                marginTop: "1px !important"
              },

              // active step's dot and label
              "& .MuiStepIcon-root.Mui-active": {
                width: "8px !important",
                height: "8px !important",
                marginTop: "2.5px !important",
                stroke: "#163073 !important",
                color: "#163073 !important",
                borderColor: "#163073 !important",
              },
              // completed step
              "& .MuiStepIcon-root.Mui-completed": {
                width: "8px !important",
                height: "8px !important",
                marginTop: "2.5px !important",
                stroke: "#163073 !important",
                color: "#163073 !important",
                borderColor: "#163073 !important",
              },

              // step label
              "& .MuiStepLabel-label": {
                color: "#4F4F4F",
                fontSize: "16px",
                fontWeight: "600",
                paddingTop: "10px"
              },
              "& .MuiStepLabel-label.Mui-active": {
                color: "#4F4F4F !important",
                fontSize: "16px !important",
                fontWeight: "600 !important",
              },
              "& .MuiStepLabel-label.Mui-completed": {
                color: "#4F4F4F !important",
                fontSize: "16px !important",
                fontWeight: "600 !important",
              },
            }}
          >
            {steps.map((label, index) => {
              const isFirst = index === 0;
              const isLast = index === steps.length - 1;
              return (
                <Step key={label}>
                  <StepLabel
                    sx={{
                      color: "gt_primary",
                      "& .MuiStepLabel-label": {
                        lineHeight: isMobile ? 1.4 : 1.6,
                        fontSize: isMobile ? 14 : 16,
                        height: "20px",
                        ...(isFirst && { paddingLeft: "60px" }),
                        ...(isLast && { paddingRight: "60px" }),
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              );
            })}

          </Stepper>
          {activeStep === steps.length ? (
            <></>
          ) : (
            <>
              <Container sx={{padding: "0 !important"}} >{renderStep()}</Container>
              {testStatus &&
                assessment &&
                assessment.currentStep !== BEGIN_TEST && (
                <Container
                    sx={{
                      backgroundColor: "#FFF",
                      width: "auto",
                      color: "white",
                      height: "4rem",
                      display: "flex",
                      alignItems: "center",
                      padding: "0 1rem",
                      position: "fixed",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 999,
                      borderRadius: "16px",
                      boxShadow: "0px -4px 19.1px 0px rgba(0, 0, 0, 0.20)"
                    }}
                  >
                  <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
                    {activeStep !== 0 && (
                      <SoftButton
                        variant="text"
                        color="gt_primary"
                        onClick={handleBack}
                        sx={{
                          flex: 0.5,
                          padding: "8px 0px",
                          borderRadius: "8px",
                          border: "1px solid #163073",
                          backgroundColor: "#163073",
                          color: "#FFF",
                          textTransform: "none",
                          fontSize: "14px",
                          fontWeight: "700",
                          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                          transition: "all 0.2s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.02)",
                          fontSize: "15px",
                          color: "#FFF",
                          backgroundColor: "#12265c",
                        },
                        "&:active": {
                          color: "#FFF",
                          backgroundColor: "#12265c",
                          boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.2)",
                        },
                        "&:focus": {
                          color: "#FFF !important",
                          backgroundColor: "#163073 !important",
                          outline: "none",
                        },
                      }}
                      >
                        Back
                      </SoftButton>
                    )}

                    {activeStep !== steps.length - 1 && (
                      <SoftButton
                        variant="text"
                        color="gt_primary"
                        onClick={handleNext}
                        sx={{
                          flex: activeStep === 0 ? 0.25 : 0.5,
                          marginLeft: activeStep === 0 ? "auto" : 0,
                          padding: "8px 0px",
                          borderRadius: "8px",
                          border: "1px solid #163073",
                          backgroundColor: "#163073",
                          color: "#FFF",
                          textTransform: "none",
                          fontSize: "14px",
                          fontWeight: "700",
                          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                          transition: "all 0.2s ease-in-out",
                          "&:hover": {
                            transform: "scale(1.02)",
                            fontSize: "15px",
                            color: "#FFF",
                            backgroundColor: "#12265c",
                          },
                          "&:active": {
                            color: "#FFF",
                            backgroundColor: "#12265c",
                            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.2)",
                          },
                          "&:focus": {
                            color: "#FFF !important",
                            backgroundColor: "#163073 !important",
                            outline: "none",
                          },
                        }}
                      >
                        Next
                      </SoftButton>
                    )}
                    {activeStep === steps.length - 1 && (
                      <SoftButton
                        variant="text"
                        color="gt_primary"
                        onClick={handleFeedback}
                        sx={{
                          flex: activeStep === 0 ? 0.25 : 0.5,
                          marginLeft: activeStep === 0 ? "auto" : 0,
                          padding: "8px 0px",
                          borderRadius: "8px",
                          backgroundColor: hasValidationError ? "#ccc" : "#163073",
                          border: hasValidationError ? "1px solid #ccc" : "1px solid #163073",
                          color: "#FFF",
                          textTransform: "none",
                          fontSize: "14px",
                          fontWeight: "700",
                          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                          transition: "all 0.2s ease-in-out",
                          pointerEvents: hasValidationError ? "none" : "auto",
                          "&:hover": {
                            transform: hasValidationError ? "none" : "scale(1.02)",
                            fontSize: hasValidationError ? "14px" : "15px",
                            backgroundColor: hasValidationError ? "#ccc" : "#12265c",
                            color: "#FFF"
                          },
                          "&:active": {
                            backgroundColor: hasValidationError ? "#ccc" : "#12265c",
                            boxShadow: hasValidationError
                              ? "none"
                              : "0px 0px 4px rgba(0, 0, 0, 0.2)",
                          },
                          "&:focus": {
                            backgroundColor: hasValidationError ? "#ccc" : "#163073",
                            outline: "none",
                          },
                        }}
                      >
                      Submit Feedback
                    </SoftButton>
                    
                    )}
                  </Box>
                </Container>
                )}
            </>
          )}
        </div>
      </div>
    );
  };

  function getDiffs(text1, text2) {
    try {
      const dmp = new diff_match_patch();
      const diffs = dmp.diff_main(text1, text2);
      dmp.diff_cleanupSemantic(diffs);
      return diffs;
    } catch (error) {
      return [];
    }
  }

  const getDateStr = (assessment3) => {
    let dateString = "";
    const date = new Date(assessment3.createdAt.seconds * 1000);
    dateString = date.toLocaleDateString("en-US", {
      minute: "2-digit",
      hour: "2-digit",
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
    });
    return dateString;
  };

  const getCandidateInfo = (isPdf) => {
    return (
      <>
        <SoftBox pt={2} mb={1}>
          <SoftTypography variant="body1" style={{color: "#4F4F4F", fontSize: "24px", fontWeight: "700"}}>
            Candidate Information
          </SoftTypography>
        </SoftBox>
        <Card variant="outlined" sx={{borderRadius: "10px"}}>
          <SoftBox pt={1} pb={1} px={2}>
            <SoftBox
              component="ul"
              display="flex"
              flexDirection="column"
              p={0}
              m={0}
            >
              <SoftBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                borderRadius="lg"
                p={1}
                mb={0}
              >
                <SoftTypography variant="button" textTransform="capitalize" style={{color: "#163073", fontSize: "18px", fontWeight: "700"}}>
                  {user.firstName} {user.lastName}
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                borderRadius="lg"
                p={1}
                pb={0}
                mb={0}
              >
                <SoftTypography variant="h7" color="text" style={{color: "#9D9D9D", fontSize: "16px", fontWeight: "600"}}>
                  Email:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <SoftTypography variant="h7" style={{color: "#4F4F4F", fontSize: "16px", fontWeight: "600"}}>
                    {user.email}
                  </SoftTypography>
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                borderRadius="lg"
                p={1}
                pb={0}
                mb={0}
              >
                <SoftTypography variant="h7" color="text" style={{color: "#9D9D9D", fontSize: "16px", fontWeight: "600"}}>
                  Phone:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <SoftTypography variant="h7" style={{color: "#4F4F4F", fontSize: "16px", fontWeight: "600"}}>
                    {user.phoneNumber || user.phone}
                  </SoftTypography>
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                borderRadius="lg"
                p={1}
                pb={2}
                mb={0}
              >
                <SoftTypography variant="h7" color="text" style={{color: "#9D9D9D", fontSize: "16px", fontWeight: "600"}}>
                  Code:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <SoftTypography variant="h7" style={{color: "#4F4F4F", fontSize: "16px", fontWeight: "600"}}>
                    {user.uid}
                  </SoftTypography>
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </>
    );
  };

  const getLineItem = (isLongBox, label, value, reason) => (
    <SoftBox
      key={label}
      display="flex"
      // alignItems="center"
      alignItems="flex-start"// ensures top alignment
      sx={{
        minHeight: "32px",
        py: 1,
        flexWrap: "wrap"
      }}
    >
      {/* Label */}
      <SoftTypography
        variant="body2"
        display="flex"
        sx={{ width: isLongBox? "60%" : "25%", color: "#4F4F4F", fontWeight: 400 }}
      >
        {label} 
      </SoftTypography>
  
      {/* Vertical Divider */}
      <SoftBox
        sx={{
          position: "absolute",
          left: isLongBox? "60%" : "25%",
          top: "-0.5rem",
          height: "calc(100% + 1.5rem)",
          width: "1px",
          backgroundColor: "#E0E0E0"
        }}
      />
      {reason? (getReasons(false, true)): (<SoftTypography
        variant="h7"
        sx={{
          flex: 1,
          top: "0px",
          textAlign: "left",
          paddingLeft: 2,
          color: "#333333",
          fontWeight: 600,
          fontSize: "16px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word"
        }}
      >
        {value}
      </SoftTypography>)}
    </SoftBox>
  );

  const getRecruiterScores = () => {
  
    const recruiterOutcomeLabel = outcomeOptions1.find((option) => 
      option.value === recruiterOutcome)?.label || recruiterOutcome;
    const hasCefrOrSpeaking = assessment?.steps?.some(
      step => step.startsWith("cefr_") || step.startsWith("speaking_") || step.startsWith("audio_scenario_")
    );
    
    const noShowCefr =
      assessment?.test_name === "old" ||
      assessment?.test_name === "all" ||
      !hasCefrOrSpeaking;
      

    return (
      <>
        <SoftBox pt={2} mb={1}>
          <SoftTypography variant="body1" style={{ color: "#4F4F4F", fontSize: "24px", fontWeight: "700" }}>
            Recruiter Assessed Score
          </SoftTypography>
        </SoftBox>
        <Card variant="outlined" sx={{borderRadius: "10px", marginBottom: "30px"}}>
          <SoftBox pt={1} pb={2} px={2}>
            {assessment.feedbackBy && getLineItem(false, "Feedback by", assessment.feedbackBy || "")}
            {assessment.feedbackAt && getLineItem(false, "Feedback on", assessment.feedbackAt.toDate().toLocaleString() || "")}
            {getLineItem(false, "Region", assessment.region || "N/A")}
            {!noShowCefr &&  getLineItem(false, "Recruiter CEFR Score", cefrScoreRecruiter)}
            {getLineItem(false, "Status", recruiterOutcomeLabel)}
            {getLineItem(false, "Feedback", feedback)}
            {getLineItem(false, "Reason", '',true, true)}

          </SoftBox>
        </Card>
        </>
        )
  }
  const getCandidateScores = (isLongBox = true) => {

    let weightedSpeakingScore = null;
    const introScore = assessment.hasOwnProperty("speaking_intro_score") ? parseFloat(assessment.speaking_intro_score) : null;
    const topicScore = assessment.hasOwnProperty("speaking_topic_score") ? parseFloat(assessment.speaking_topic_score) : null;
    const interactionScore = assessment.hasOwnProperty("speaking_interaction_score") ? parseFloat(assessment.speaking_interaction_score) : null;

    if (
      introScore !== null &&
      topicScore !== null &&
      interactionScore !== null
    ) {
      const totalWeightedScore = introScore * 2 + topicScore * 4 + interactionScore * 4;
      weightedSpeakingScore = parseFloat((totalWeightedScore / 10).toFixed(2));
    }

    // Helper to convert numeric score (0-100) to grade label
    const scoreToGrade = (score) => {
      if (score === null || score === undefined) return null;
      const numScore = parseFloat(score);
      if (isNaN(numScore)) return null;
      if (numScore <= 12.5) return "Poor";
      if (numScore <= 37.5) return "Below Average";
      if (numScore <= 62.5) return "Average";
      if (numScore <= 87.5) return "Good";
      return "Excellent";
    };

    // Compute cumulative audio scenario scores — dynamically average all care and retention scores present
    const careScoreKeys = ["audio_scenario_care_score", "audio_scenario_care_2_score", "audio_scenario_care_3_score"];
    const careScores = careScoreKeys
      .filter(k => assessment.hasOwnProperty(k) && assessment[k] != null && !isNaN(parseFloat(assessment[k])))
      .map(k => parseFloat(assessment[k]));
    const scenarioCareAvg = careScores.length > 0 ? careScores.reduce((a, b) => a + b, 0) / careScores.length : null;

    const retScoreKeys = ["audio_scenario_retention_score", "audio_scenario_retention_2_score"];
    const retScores = retScoreKeys
      .filter(k => assessment.hasOwnProperty(k) && assessment[k] != null && !isNaN(parseFloat(assessment[k])))
      .map(k => parseFloat(assessment[k]));
    const scenarioRetAvg = retScores.length > 0 ? retScores.reduce((a, b) => a + b, 0) / retScores.length : null;

    const scoreFields = [
      { key: "region", label: "Region" },
      { key: "cefr_score", label: "CEFR Score" },
      { key: "listeningScore", label: "Listening Score" },
      { key: "vocabScore", label: "Vocabulary Score" },
      { key: "aptitude_score", label: "Apptitude w/Technical Score" },
      { key: "aptitude_technical_score", label: "Apptitude & Technical Score" },
      { key: "integrity_score", label: "Integrity Score" },
      { key: "integrity_score_es", label: "Puntuación de integridad" },
      { key: "attendance_score", label: "Attendance Score" },
      { key: "attendance_score_es", label: "Puntuación de asistencia" },
      { key: "comprehensive_score", label: "Comprehension Score" },
      { key: "ei_score", label: "Emotional Intelligence Score" },
      { key: "ei_score_es", label: "Puntuación de inteligencia emocional" },
      { key: "cck_score", label: "Call Center Knowledge Score" },
      { key: "cck_score_es", label: "Puntuación de conocimiento del centro de llamadas" },
      { key: "cs_score", label: "Customer Service Score" },
      { key: "cs_score_es", label: "Puntuación de servicio al cliente" },
      { key: "ts_score", label: "Technical Proficiency Score" },
      { key: "sales_score", label: "Sales Score" },
      { key: "sales_retention_score", label: "Sales Retention Score" },
      { key: "attention_score", label: "Attention to Detail Score" },
      { key: "reading_similarity", label: "Reading Similarity" },
     
      { key: "tel_com_score", label: "Telecommunication & Broadband Score" },

      { key: "sales_retention_b2b_score", label: "B2B Score" },
      { key: "b2b_sales_listening_score", label: "B2B Listening" },

      { key: "sales_enablement_listening_score", label: "Sales Enablement Listening Score" },
      { key: "tspr_score", label: "Troubleshooting/Problem resolution Score" },
      
      { key: "upselling_cs_listening_score", label: "Upselling Listening Score" },
      { key: "upselling_cs_score", label: "Upselling Score" },

      { key: "wee_score", label: "Writing Etiquette & Email Structure Score" },
      { key: "wde_score", label: "Written De-Escalation Tactics Score" },
      { key: "ps_score", label: "Problem Solving Skills Score" },
      { key: "grammar_empathy_score", label: "Grammar & Empathy Score" },
      { key: "chat_scenario_score", label: "Chat Scenario Score" },


      // { key: "cefr_listening_score", label: "CEFR Listening Score" },
      // { key: "cefr_reading_score", label: "CEFR Reading Score" },
      // { key: "cefr_writing_score", label: "CEFR Writing Score" },
      { key: "retention_listening_score", label: "Retention Listening Score" },
      { key: "altice_question_score", label: "Altice Questions Score" },

      // CEFR Speaking & Writing scores are shown in their own detailed sections — not in Candidate Score summary
      // { key: "speaking_cumulative", label: "Speaking Score", value: scoreToGrade(weightedSpeakingScore) },
      // { key: "cefr_writing_cumulative", label: "Writing Score", value: scoreToGrade(assessment?.cefr_writing_score != null ? parseFloat(assessment.cefr_writing_score) : null) },

      // Cumulative audio scenario scores (displayed as grade labels)
      { key: "scenario_care_cumulative", label: "Scenario Care Score", value: scoreToGrade(scenarioCareAvg) },
      { key: "scenario_retention_cumulative", label: "Scenario Retention Score", value: scoreToGrade(scenarioRetAvg) },
    ];
  
    return (
      <>
          {isLongBox ? (
            
          <Card variant="outlined" 
            sx={{ 
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0, 
              height: "auto" 
              }}
          >
            <SoftTypography variant="body1"   
            sx={{ borderBottom: "1px solid #E0E0E0" }}
            style=
              {{ 
                paddingTop: "5px",
                paddingBottom: "5px",
                paddingLeft: "10px", 
                color: "#4F4F4F", 
                fontSize: "24px", 
                fontWeight: "700",
              }}>
              Candidate Score
            </SoftTypography>
          </Card>
          ) : ( 
            <SoftBox pt={2} mb={1}>
              <SoftTypography variant="body1" style={{ color: "#4F4F4F", fontSize: "24px", fontWeight: "700" }}>
                Candidate Score 
              </SoftTypography>
            </SoftBox>   
          )}        
          <Card variant="outlined" sx={{ 
            borderTopLeftRadius: isLongBox ? 0: '10px',
            borderTopRightRadius: isLongBox ? 0: '10px',
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            mb: 3, height: isLongBox ? "620px" : "auto" }}>

          <SoftBox pt={1} pb={2} px={2}>
            <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
              {scoreFields.map(({ key, label, value }) => {
                let fieldValue = value !== undefined ? value : assessment[key];
  
                if (!isNaN(fieldValue) && typeof fieldValue === "number") {
                  fieldValue = fieldValue.toFixed(2);
                }
                if (fieldValue !== null && fieldValue !== undefined && fieldValue !== "") {
                  return getLineItem(isLongBox, label, `${fieldValue} ${!isNaN(fieldValue) && key !== "region" ? "%" : ""}`);
                }
                return null;
              })}
              {assessment?.typing_test?.[0]?.wpm !== undefined &&
                getLineItem(isLongBox, "Typing Speed", `${assessment.typing_test[0].wpm} WPM`)}
              {assessment?.typing_test?.[0]?.accuracy !== undefined &&
                getLineItem(isLongBox, "Typing Accuracy", `${assessment.typing_test[0].accuracy} %`)}
              {getLineItem(isLongBox, "Overall time", startTime)}
              {isLongBox && (
                <>
                  {Array.from({ length: 10 }).map((_, index) => (
                    getLineItem(isLongBox, "", "")
                  ))}
                </>
              )}
            </SoftBox>
          </SoftBox>
        </Card>
      </>
    );
  };

  const getCameraSnapshotPage = () => {
    if(!isExporting) {
      return (
        <SoftBox mt={4} pb={8}>
          <SoftTypography
            variant="body1"
            sx={{ color: "#4F4F4F", fontSize: "24px", fontWeight: "700" }}
          >
            Camera Shots
          </SoftTypography>

          {loadingImages ? (
            <RotatingLines
              strokeColor="black"
              strokeWidth="5"
              animationDuration="0.75"
              width="50"
              visible={true}
            />
          ) : (
            <Card
              variant="outlined"
              sx={{
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
                borderRadius: "12px",
                p: 2,
              }}
            >
              {imageUrls?.message ? (
                <SoftTypography variant="body2"
                sx={{ fontWeight: 500, color: "#5569ED" }}>
                  {imageUrls.message}
                </SoftTypography>
              ) : (
                <>
                  <SoftBox
                    display="grid"
                    gridTemplateColumns="repeat(auto-fill, minmax(160px, 1fr))"
                    gap={2}
                    mb={2}
                    justifyContent="center"
                  >
                    {imageUrls.map((snapshot, index) => (
                      <SoftBox key={index} textAlign="center">
                        <img
                          src={snapshot.url}
                          alt={`Snapshot ${index + 1}`}
                          onLoad={() =>
                            updateMediaStatus({
                              imageLoaded: true,
                            })
                          }
                          style={{
                            width: "100%",
                            maxWidth: "160px",
                            height: "100px",
                            borderRadius: "10px",
                            objectFit: "cover",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            margin: "0 auto",
                          }}
                        />
                        <SoftTypography
                          variant="h7"
                          style={{
                            color: "#9D9D9D",
                            fontSize: "12px",
                            fontWeight: "600",
                            flex: 0.3,
                          }}
                        >
                          {new Date(snapshot.timestamp).toLocaleString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </SoftTypography>
                      </SoftBox>
                    ))}
                  </SoftBox>

                  <SoftTypography
                    variant="caption"
                    sx={{ fontWeight: 500, color: "#5569ED" }}
                  >
                    Camera shots will be automatically deleted after 6 months.
                  </SoftTypography>
                </>
              )}
            </Card>
          )}
        </SoftBox>
      );
    }
  };
  
  const renderStep = () => {
    if (isSinglePage) {
      return (
        <>
          {getScreeningPage()}
          {getReviewRecordingPage()}
          {getQuestionsPage()}
          {getWritingPage()}
          {getListeningPage()}
          {getFeedbackPage()}
        </>
      );
    } else {
      switch (steps[activeStep]) {
        case SCREENING:
          return getScreeningPage();
        case REVIEW_RECORDING:
        case REVIEW_SPEAKING:
          return getReviewRecordingPage();
        case REVIEW_QUESTIONS:
          return getQuestionsPage();
        case REVIEW_WRITING:
          return getWritingPage();
        case REVIEW_LISTENING:
          return getListeningPage();
        case FEEDBACK:
          return getFeedbackPage();
        default:
          return null;
      }
    }
  };

  if (isLoading) {
    return <MySpinner />;
  }
  return (
    <div>
      <Banner showBackButton={true} />
      {success && (
        <div style={{ textAlign: "center", margin: "10px" }}>Email Sent</div>
      )}
      {renderStep2()}
      <Container
        id="my-pdf"
        style={{ display: "none" }}
      >
        {getScreeningPage(true)}
        {getReviewRecordingPage(true)}
        {getQuestionsPage(true)}
        {getWritingPage(true)}
        {getListeningPage(true)}
        {getFeedbackPage(true)}
      </Container>
    </div>
  );
}
